var messages = {
  privacy: {
    title: "نصائح استخدام خدمة vTrack",
    text1: "شكرا لك على ثقتك، مرحبا بك باستخدام vTrack",
    text2: "من أجل حماية حقوقك ومصالحك بشكل أفضل، يرجى قراءتها بعناية وفهمها بالكامل",
    text3: "اتفاق المستخدم وسياسة الخصوصية",
    end:
      "إذا انقرت على 'موافقة'، يعني أنك قرأت وفهمت وقبلت جميع محتويات هذه الاتفاقية بالكامل، وستكون هذه الاتفاقية ملزمة قانونا. إذا قمت بالنقر فوق 'لا توافق'، يمكنك الخروج من هذه الصفحة."
  },
  alert: {
    cancelButtonText: "إلغاء",
    confirmButtonText: "تأكيد",
    cancellationText: "هل أنت متأكد من تعطيل الحساب؟",
    updateText: "هذه الصفحة هي وحدة جديدة. يرجى تحديث أحدث نسخة والمحاولة مرة أخرى",
    networkError: "خطأ في الشبكة",
    unavailable: "تتطلب هذه الميزة الوصول إلى العميل لاستخدامها",
    download: "اذهب للتحميل",
    reload: "إعادة التحميل"
  },
  meta: {
    homePage: "الصفحة الرئيسية",
    userPage: "المستخدم",
    userManagement: "إدارة المستخدم",
    search: "بحث",
    more: "المزيد",
    upload: "تحميل",
    uploadSuccess: "نجاح التحميل",
    uploadFail: "فشل التحميل",
    loading: "التحميل",
    privacy: "اتفاق المستخدم وسياسة الخصوصية",
    aboutUs: "نبذة عنا",
    accountDelete: "إلغاء الحساب",
    kefuList: "خدمة العملاء",
    agree: "موافق",
    disagree: "غير موافق",
    noMore: "لا مزيد",
    input: "يرجى الإدخال",
    require: "الحقول المطلوبة",
    select: "يرجى الاختيار",
    filter: "الفلتر",
    all: "جميع",
    allFilter: "الكل المرشّح",
    dateFilter: "تصفية التاريخ",
    view: "منظر",
    viewClick: "انقر فوق عرض",
    reset: "إعادة الضبط",
    confirm: "أكد",
    cancel: "الإلغاء",
    close: "أغلق",
    save: "احفظ",
    delete: "احذف",
    date: "التاريخ",
    beginDate: "تاريخ البدء",
    to: "إلى",
    endDate: "تاريخ الانتهاء",
    edit: "تحرير",
    editButton: "تحرير / عرض",
    disable: "قم بتعطيل",
    enable: "تمكين",
    display: "شاشة العرض",
    hide: "أختبئ",
    effective: "الفعالية",
    searchText: "كلمات البحث الأساسية",
    searchType: "ظروف البحث",
    print: "اطبع",
    copy: "انسخ",
    copySuccess: "نجاح النسخ",
    operate: "تشغيل",
    operateSuccess: "نجاح التشغيل",
    detail: "التفاصيل",
    basicTitle: "المعلومات الأساسية",
    customerTitle: "نوع العميل",
    country: "البلد",
    city: "المدينة",
    menu: "التشغيل",
    submit: "أرسِل",
    chagreTitle: "عناصر الرسوم",
    currency: "العملة",
    statistics: "البيانات والظروف الإحصائية",
    businessType: "أنواع الأعمال",
    wbType1: "شحن جوي",
    wbType2: "شحن بحري",
    wbType3: "من الجو إلى الباب",
    wbType4: "من البحر إلى الباب",
    wbType5: "سريع",
    wbType6: "من الجو الى الباب",
    wbType7: "من البحر الى الباب",
    wbType8: "الجمارك",
    wbType9: "النقل البري",
    isConsolidation: "التدعيم",
    year: "",
    month: "",
    day: "",
    saveToAlbum: "حفظ إلى الألبوم",
    prevPage: "الصفحة السابقة",
    nextPage: "الصفحة التالية",
    noData: " لا يوجد بيانات",
    yes: "نعم",
    no: "لا",
    enterprise: "شركة",
    personal: "شخصي",
    systemLanguage: "لغة النظام",
    autoLanguage: "اتبع النظام",
    saveSuccess: "احفظ النجاح",
    saveError: "فشل الحفظ",
    printError: "خطأ في الطباعة",
    notice: "إشعار",
    deleteConfirm: "هل أنت متأكد من حذف هذه البيانات؟",
    backHome: "المنزل",
    viewDetail: "عرض التفاصيل",
    paySuccess: "نجاح عملية الدفع",
    payFailure: "فشل عملية الدفع",
    selectTotal: "اختر-إجمالي",
    showStatistics: "إظهار الإحصائيات",
    hideStatistics: "إخفاء الإحصائيات",
    website: "الموقع الإلكتروني",
    newVersion: "اكتشف نسخة جديدة",
    updateButton: "التحديث الآن",
    laterButton: "غدا",
    scanTitle: "افحصوا الكوركود",
    scanDes: "يرجى مسح رمز الاستجابة السريعة أو الشريط الشهادي",
    scanButton: "اختر من معرض الصور",
    scanError1: "الاعتراف فشل. يرجى تحديد رمز الاستجابة السريعة الصحيح",
    scanError2: "الكاميرا غير متوفرة الرجاء تمكين أذونات الكاميرا",
    popover1: "المسح الضوئي",
    popover2: "اللغة",
    scanNotice1: "يرجى مسح رمز الاستجابة السريعة (QR) باستخدام Alipay للدفع",
    scanNotice2: "يرجى مسح رمز الاستجابة السريعة (QR) باستخدام واتش للدفع",
    setPointRule: "قواعد النقاط",
    addRule: "إنشاء قاعدة النقاط",
    deleteRule: "قاعدة حذف النقاط",
    viewRuleHistory: "تُظهر وجهات النظر تاريخ القواعد",
    pointsObtainConditions: "النقاط التي تُحصل عليها تحت شروط",
    pointsIncome: "دخل النقاط",
    reducedPointsIncome: "إيرادات النقاط المخفضة",
    ruleDate: "تاريخ التخلص",
    add: "أضف",
    goToCreate: "اذهب لإنشاء",
    noImage: "لا صور",
  },
  router: {
    home: "vTrack",
    print: "اطبع صفحة",
    enterpriseWorkbench: "منضدة عمل المؤسسة",
    workbenchBank: "رقم حسابي البنكي",
    workbenchSupplier: "جامع معلومات الموردين",
    buildWayBillNo: "إنشاء رقم بوليصة الشحن",
    checkWaybill: "إدارة الاستعلام",
    checkWaybillDetail: "تفاصيل أمر فاتورة الطريق",
    billsReceivable: "إشعار مدين",
    supplierCostEntry: "تكاليف المورد",
    logisticsStatus: "حالة اللوجستيات",
    jobSummary: "ملخص المهام",
    orderWayBill: "مركز الطلبات",
    orderWayBillDetail: "تفاصيل الطلب",
    goodsFiles: "مركز ملفات البضائع",
    goodsFilesDetail: "تفاصيل ملفات البضائع",
    preAlertDetail: "التفاصيل Pre-Alert",
    basicInfo: "قائمة العملاء",
    basicInfoDetail: "تفاصيل العميل",
    basicInfoAgentList: "قائمة الوكلاء الخارجيين",
    basicInfoAgentDetail: "تفاصيل الوكلاء الخارجيين",
    banckAccountInfo: "قائمة الحسابات المصرفية",
    banckAccountInfoDetail: "تفاصيل الحساب البنكي",
    contactStaff: "قائمة جهات الاتصال",
    contactStaffDetail: "تفاصيل جهة الاتصال",
    contractManagement: "إدارة العقود",
    contractManagementDetail: "تفاصيل العقد",
    receivingAccountManagement: "أستلم قائمة الحسابات",
    receivingAccountManagementDetail: "أستلم تفاصيل الحساب",
    expenseNameManagement: "قائمة سداد الفواتير",
    expenseNameManagementDetail: "تفاصيل دفع الفاتورة",
    exchangeRateInfo: "قائمة أسعار الصرف",
    exchangeRateInfoDetail: "إنشاء معدل",
    exchangeRateInfoLog: "سجل أسعار الصرف",
    invoiceItemList: "قائمة عناصر الفاتورة",
    invoiceItemListDetail: "تفاصيل عنصر الفاتورة",
    reportQuerySummary: "ملخص الاستعلام",
    payrollDetails: "طلب دفع العمل",
    payrollList: "طلب دفع تشغيلي",
    payrollRequest: "طلب تكلفة التشغيل",
    payrollPayment: "دفع طلب العملية",
    payrollRecords: "معلومات سجل الدفع",
    reportQuerySummaryDetail: "التحصيل والدفع",
    profitableList: "قائمة مربحة",
    profitableListDetail: "تفاصيل إحصاءات الأرباح",
    finishedCheckBillsSummary: "تم فحص الفواتير منتهية الصلاحية",
    finishedCheckBillsSummaryDetail: "الفواتير المنتهية دقّقت التفاصيل",
    creditedDetails: "القائمة المعتمدة",
    creditedDetailsInfo: "تفاصيل نقاط",
    taxInvoice: "فاتورة الضرائب",
    taxInvoiceDetail: "تفاصيل الفاتورة",
    financialRequest: "الطلب المالي",
    financialRequestDetail: "طلب التفاصيل",
    financialAudit: "مراجعة الحسابات المالية",
    financialAuditDetail: "تفاصيل التدقيق",
    paymentInvoice: "فاتورة الدفع",
    cargoStatistics: "إحصاءات الشحن",
    lineChartStatistics: "إحصاءات المخطط الخطي",
    expenseStatistics: "إحصائيات النفقات",
    expenseStatisticsDetail: "طلب قائمة تفاصيل",
    customerBusinessStatistics: "إحصائيات أعمال العملاء",
    customerBusinessStatisticsDetail: "تفاصيل دفع العميل",
    customerBusinessStatisticsCustomerInfo: "إيصالات أو مدفوعات",
    seaFreightDataStatistics: "إحصاءات بيانات الشحن البحري",
    seaFreightDataStatisticsDetail: "بيانات الشحن البحري التفصيلية",
    warehouseList: "إدارة المخازن",
    warehouseDetail: "معلومات المخازن",
    warehouseSettings: "إعداد نموذج المستودع",
    warehouseSettingsDetail: "إعدادات محتوى نموذج المستودع",
    warehouseDelivery: "تسليم المستودع",
    warehouseDeliveryDetail: "تفاصيل توصيل المستودع",
    warehouseBill: "أمر دخول المستودع",
    warehouseBillDetail: "طلب عمل في المستودع",
    warehouseProfitAccounting: "حصيلة أرباح المخازن",
    warehouseOperationLogList: "سجلات عمليات الشحن",
    advertList: "قائمة التحويل",
    advertDetail: "تحويل التفاصيل",
    restrictedList: "قائمة مقيدة",
    restrictedDetail: "تفاصيل مقيدة",
    emailConfig: "تهيئة البريد الإلكتروني",
    emailConfigDetail: "تفاصيل التكوين",
    quoteList: "قائمة اقتباسات",
    quoteDetail: "تفاصيل عرض الأسعار",
    quoteCreate: "ورقة عرض أسعار",
    orderCenterList: "قائمة مركز الطلبات",
    commissionDetail: "تفاصيل الوصاية",
    commissionCreate: "ترتيب الشحن SOP",
    accountingList: "قائمة محاسبة",
    accountingDetail: "تفاصيل المحاسبة",
    supplierServiceInformation: "معلومات خدمة الموردين",
    supplierInformation: "معلومات المورد",
    answerDetail: "قائمة رد الموردين",
    overseasGrid: "الشبكة الخارجية",
    overseasDetail: "عرض أسعار الوكلاء الخارجيين",
    assetsStatistics: "إحصاءات الأصول",
    assetsStatisticsDetail: "تفاصيل إحصاءات الأصول",
    assetsStatisticsRecord: "سجل تسليم الخدمة",
    employeeInformation: "معلومات ملف الموظف",
    employeeManagement: "إدارة الموظفين",
    employeeDetail: "تفاصيل الموظفين",
    privacy: "اتفاق المستخدم وسياسة الخصوصية",
    accountDeletion: "إلغاء الحساب",
    aboutUs: "بشأننا",
    kefuList: "خدمة العملاء",
    currencySettings: "إعداد العملة",
    currencySettingsDetail: "تفاصيل العملة",
    invoiceTitle: "عنوان الفاتورة",
    consumptionRecord: "رقم استهلاكي قياسي",
    financialAuditProcessSettings: "إعداد عملية المراجعة المالية",
    getWayBillOperationLog: "سجل العمليات",
    expenseCategorySettings: "إعدادات فئة النفقات",
    userList: "قائمة المستخدمين",
    userDetail: "معلومات المستخدم",
    roleList: "قائمة الأدوار",
    roleDetail: "اضبط يمينا",
    store: "المتجر",
    payCompletion: "الدفع",
    payQrcode: "المسح للدفع",
    accountStatements: "كشف الحساب",
    accountStatementsDetail: "عرض تفاصيل تحويل أموال العميل",
    clientFundDetail: "تفاصيل صندوق العميل",
    clientFundUseList: "تفاصيل استخدام أموال العملاء",
    clientFundExchange: "سجل صرف أموال العملاء",
    clientFundDataList: "قائمة تفاصيل البيانات",
    businessEntry: "إدخال أعمال صندوق العميل",
    businessEntryDetail: "تفاصيل إدخال الأعمال",
    financeEntry: "إدخال تمويل صندوق العملاء",
    financeEntryDetail: "تفاصيل القيد المالي",
    clientFundDetailExchange: "صرف أموال العملاء",
    clientFundDetailWriteOff: "تم إلغاء صندوق العملاء",
    antiMoneyLaunderingList: "قائمة مكافحة الأموال",
    antiMoneyLaunderingDetail: "تفاصيل مكافحة الأموال",
    antiMoneyLaunderingQuery: "نتائج استعلام مكافحة المال",
    temuManifestList: "قائمة الطلبات TEMU",
    temuManifestDetail: "تفاصيل الطلب TEMU",
    tmsDetail: "معلومات الطلب TMS",
    vehiclesList: "إدارة المركبات",
    vehiclesDetail: "تفاصيل المركبة",
    expressEmployeeList: "قائمة الموظفين السريعة",
    expressEmployeeDetail: "توضيح تفاصيل الموظف",
    cargoWarehousingList: "إدارة نقل البضائع",
    cargoWarehousingDetail: "تفاصيل النقل",
    cargoWarehousing: "المواصلات تعمل",
    cargoWarehousingException: "التعامل مع استثناءات الأمر",
    cargoWarehousingExceptionRecords: "سجل الاستثناء",
    quotationManagement: "إدارة عروض الأسعار",
    quotationWarehouse: "معلومات المخازن",
    quotationInformation: "معلومات عروض الأسعار",
    quotationFreight: "معلومات الشحن",
    quotationCustomerDiscount: "خصم للعميل",
    quotationCustomerDiscountDetail: "تفاصيل خصم العميل",
    quotationSupplierCreate: "تفاصيل عرض المورد",
    waitingForStorage: "قائمة المخازن",
    hasBeenStored: "قائمة مخزنة",
    hasBeenStoredDetail: "قم بتوليد رقم بيان النقل",
    departed: "قائمة الشحن",
    departedDetail: "طلبات العملاء",
    freightPriceCalculator: "حاسبة أسعار الشحن",
    cargoWarehousingEditAddress: "تعديل عنوان الشحن",
    businessEntitySettings: "إعدادات الكيان التجاري",
    businessEntitySettingsDetail: "تفاصيل الكيان التجاري",
    goodsInventory: "شراء مخزون البضائع",
    goodsInventoryCreate: "تفاصيل المنتج",
    goodsInventoryQuotation: "استعلام عن المنتج",
    goodsInventoryQuotationDetail: "تفاصيل الاقتباس",
    tradeOrder: "طلب تجاري",
    tradeOrderCreate: "إنشاء أمر تجاري",
    tradeOrderReconciliation: "تقويم رأس المال للعميل",
    procurementQuotationSettings: "إعداد وحدة الاقتباس",
    procurementQuotationSettingsDetail: "تفاصيل وحدة الاقتباس",
    customerHome: "منزل العميل",
    customerInfo: "معلومات المؤسسة",
    logisticsSection: "قسم الخدمات اللوجستية",
    freightInquiry: "استفسار عن الشحن",
    freightInquiryDetail: "تفاصيل استفسار الشحن",
    customerQuotationDetail: "تفاصيل الاقتباس",
    shippingAddress: "عنوان التسليم",
    addAddress: "إنشاء عنوان التسليم ",
    editAddress: "تعديل عنوان التسليم",
    myWallet: "حقيبتي",
    paybillList: "فاتورة مستحقة الدفع",
    myWalletRechange: "إعادة شحن الحساب",
    orderManagement: "إدارة الطلبات",
    orderManagementDetail: "تفاصيل الطلب",
    quotationIntegration: "قواعد النقاط",
    quotationIntegrationHistory: "تاريخ قواعد النقاط",
    exportGoodsStatistics: "إحصائيات السلع المصدرة",
    entrustOrder: "أوكل الأمر",
    entrustOrderList: "أوكل قائمة الطلبات",
    entrustOrderCreate: "إنشاء أمر ثقة",
    entrustOrderDetail: "أوكل تفاصيل الطلب",
    freightOrder: "طلب الشحن",
    freightOrderList: "قائمة طلبات الشحن",
    freightOrderCreate: "تفاصيل طلب الشحن",
    warehouseManagement: "إدارة المستودعات",
    warehouseQuery: "استفسار عن تخزين البضائع",
    warehouseStatement: "بيان تدفق البضائع",
    debtList: "قائمة المحاسبة المالية",
    debtDetail: "البillet القابلة للدفع"
  },
  activate: {
    title1: "يرجى إدخال معلومات المستخدم",
    title2: "الرجاء إدخال معلومات الشركة",
    headImg: "أفاتار",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    save: "احفظ",
    companyLogoPic: "صورة شعار الشركة",
    businessLicence: "رخصة أعمال",
    officialSealPic: "صورة ختم رسمي",
    companyName: "اسم الشركة",
    companyProfileCn: "لمحة عن الشركة ( المنطقة المحلية )",
    companyProfileEn: "لمحة عن الشركة ( الإنجليزية )",
    legalPersonName: "الشخص الاعتباري بالشركة",
    creditCode: "رقم السجل التجاري / رقم الضريبة",
    detailAddress: "العنوان الكامل"
  },
  auth: {
    staff: "موظف داخلي",
    customer: "عميل مؤسسي",
    login: "تسجيل الدخول",
    logInSuccess: "تم تسيل الدخول بنجاح",
    inputPhoneNumber: "يرجى إدخال رقم الهاتف",
    inputEmail: "الرجاء إدخال البريد الإلكتروني",
    inputCustomerNumber: "يرجى إدخال رقم العميل",
    inputCorrentPhoneNumber: "الرجاء إدخال رقم الهاتف الصحيح",
    inputCorrentEmail: "الرجاء إدخال البريد الإلكتروني الصحيح",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    inputVcode: "يرجى إدخال رمز التحقق",
    inputUsername: "الرجاء إدخال رقم الهاتف أو البريد الإلكتروني",
    inputPassword: "يرجى إدخال كلمة السر",
    inputCompanyCode: "يرجى إدخال رمز الشركة",
    register: "تسجيل",
    setAccountInfo: " ضبط معلومات الحساب",
    sendAuthCode: " رمز البريد الإلكتروني",
    next: "التالي",
    backLogin: "العودة لتسجيل الدخول",
    verificationCodeInfo: "تم إرسال رمز التحقق",
    username: "الإسم المستعار",
    inputPaw: "أدخل رقم التعريف الشخصي لتسجيل الدخول",
    pawInfo: "8 أحرف مع مزيج الأرقام.",
    registerSuccess: "تم التسجيل بنجاح",
    correctError: "يرجى إدخال كلمة المرور الصحيحة",
    confirm: "تأكيد",
    logout: "تسجيل الخروج",
    customerNumber: "رقم العميل",
    forgetPassword: "انسى كلمة المرور",
    resetPassword: "إعادة تعيين كلمة المرور",
    freeze: "الحساب مجمد",
    newPassword1: "الرجاء إدخال كلمة السر الجديدة الخاصة بك",
    newPassword2: "الرجاء إعادة إدخال كلمة السر الجديدة",
    diffPassword: "إدخالي كلمة المرور غير متناسقين",
    activate: "تنشيط الحساب",
    role: "الدور",
    companyName: "اسم الشركة",
    companyCode: "رمز الشركة",
    tick: "يُرجى وضع علامة",
    rulesAndProtocols:
      "لقد قرأت اتفاقية المستخدم وسياسة الخصوصية ووافقت عليهما",
    pickerType1: "نوع حساب تسجيل الدخول",
    pickerType2: "سجل نوع الحساب",
    verifyText: "يجب تحقق الحساب",
    verifyCode: "رمز التحقق",
    get: "إرسال",
  },
  information: {
    title: "المعلومات الشخصية",
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    companyName: "الاسم الكامل للشركة",
    companyNameEn: "اسم الشركة باللغة الإنجليزية",
    companyNameSn: "اسم الشركة باختصار",
    legalPerson: "الممثل القانوني",
    telePhone: "رقم الهاتف",
    webSite: "الموقع الإلكتروني",
    address: "العنوان",
    certificate: "رخصة تسجيل الأعمال",
    personalPassport: "رقم جواز السفر",
    personalID: "رقم التعريف",
    personalIDSn: "رقم هوية العميل",
    customerPhone: "رقم الاتصال",
    customerPassword: "كلمة مرور العميل",
    email: "البريد الإلكتروني",
    country: "البلد",
    city: "المدينة",
    password: "كلمة السر",
    submit: "إرسال",
    save: "احفظ",
    alert: "يرجى التحقق من معلوماتك",
    userInfo: "معلومات المستخدم",
    avatar: "الصورة الرمزية",
    card: "بطاقة أعمال شخصية",
    userName: " اسم جهة الاتصال",
    phone1: "رقم الهاتف المحمول 1",
    phone2: "رقم الهاتف المحمول 2",
    fixedPhone: "ثابت سطر",
    wechat: "Wechat",
    qq: "رقم QQ",
    whatsapp: "رقم WhatsApp",
    website: "الموقع الإلكتروني",
    eCard: "بطاقة الأعمال",
    chinese: "اللغة المحلية",
    english: "الإنجليزية",
    name: "الاسم",
    department: "القسم",
    position: "المسمى الوظيفي",
    mailingAddress: "عنوان البريد",
    individualResume: "الملف الشخصي",
    serviceSectionIntroduction: "مقدمة الخدمة",
    projectCase: "حالة المشروع",
    personalSayings: "شعاري الشخصي",
    filename: "ملف",
    customizeName: "اسم مخصص",
    view: "عرض",
    upload: "تحميل",
    customerNumber: "رقم العميل",
  },
  enterpriseInfo: {
    title: "معلومات المؤسسة",
    companyInfo: "معلومات الشركة",
    companyLogo: "شعار الشركة",
    licence: "رخصة العمل",
    officialSeal: "الختم الرسمي",
    companyCode: "رمز الشركة",
    companyName: "اسم الشركة",
    companyProfileCN: "ملف تعريف الشركة (المحلية)",
    companyProfileEN: "ملف تعريف الشركة (الإنجليزية)",
    legal: "اسم المدير",
    creditCode: "رقم السجل التجاري / رقم الضريبة",
    detailAddress: "العنوان الكامل",
    submit: "إرسال ",
  },
  workbench: {
    username: "اسمي ",
    roleName: "دور النظام",
    phoneNumber: "رقم الهاتف",
    companyName: "اسم الشركة",
    eCard: "بطاقة الأعمال",
    createRequest: "تقديم طلب استرداد التكاليف ",
    myBankAccount: "رقم حسابي البنكي ",
    accountName: "اسم الحساب البنكي ",
    accountNo: "الحساب البنكي ",
    bankName: "اسم البنك",
    qrcode: "رمز الاستجابة السريعة للمحفظة الإلكترونية ",
    saveBankInfo: "حفظ معلومات البنك",
    supplierCollector: "جامع معلومات الموردين",
    shareMessageCN: "مشاركة الرسالة (المحلية)",
    shareMessageEN: "مشاركة الرسالة (بالإنجليزية)",
    shareQrCode: "رمز إستبيان",
    saveMessage: "حفظ الرسالة",
    viewButton: "عرض طلب الدفع",
    freightPriceCalculator: "حاسبة أسعار الشحن",
    h5QrCode: "محطة اللوجستيات",
  },
  employee: {
    title1: "تسجيل العملية",
    title2: "معلومات شخصية",
    title3: "جهة اتصال الطوارئ",
    title4: "تعليم",
    title5: "اللغة",
    title6: "دورة تدريبية",
    title7: "الشهادة",
    title8: "الحساب البنكي",
    title9: "تقديم الشهادة",
    photo: "صورة شخصية",
    entryDate: "تاريخ الدخول",
    position: "المنصب",
    surname: "الاسم",
    phoneNumber: "رقم الهاتف",
    idCardNumber: "رقم بطاقة الهوية",
    marital: "الحالة الاجتماعية",
    mOption1: "غير متزوج",
    mOption2: "متزوج",
    address: "العنوان",
    nationality: "الجنسية",
    nativePlace: "المكان الأصلي",
    gender: "الجنس",
    male: "ذكر",
    female: "انثى",
    birthDate: "تاريخ الميلاد",
    contactName: "اسم جهة الاتصال",
    contactPhone: "رقم هاتف جهة الاتصال",
    education: "التعليم",
    school: "خريج مدرسي",
    enrollmentDate: "تاريخ التسجيل",
    graduationDate: "سنة التخرج",
    languageName: "الاسم",
    listen: "اسمع",
    say: "قل",
    read: "اقرأ",
    write: "اكتب",
    lOption1: "عام",
    lOption2: "الممارسة",
    lOption3: "الإتقان",
    courseName: "عنوان الدورة",
    institutions: "مؤسسة التدريب",
    beginDate: "تاريخ بدء التدريب",
    endDate: "تاريخ انتهاء التدريب تاريخ انتهاء التدريب",
    certificate: "الشهادة",
    cBeginDate: "تاريخ البدء الفعلي",
    cEndDate: "تاريخ الانتهاء الفعلي",
    payeeName: "اسم المستفيد",
    bankName: "اسم البنك",
    bankAccount: "الحساب البنكي",
    idCard: "بطاقة الهوية",
    view: "عرض",
    upload: "تحميل",
    graduationBook: "شهادة التخرج",
    resignBook: "شهادة الاستقالة",
    resume: "السيرة الذاتية",
    sourceTitle: "موارد التخصيص المؤسسية",
    allocatingResource: "تخصيص الموارد",
    receivingServer: "خادم الاستقبال",
    receivePort: "منفذ الاستقبال",
    sendServer: "إرسال الخادم",
    sendPort: "إرسال المنفذ",
    fixedAssets: " الأصول الثابتة ",
    digitalAssets: " الأصول الرقمية ",
    assetType: "نوع الأصل",
    className: "اسم الفئة",
    goodsName: "إسم المنتج",
    accountNumber: "رقم الحساب",
    welcomeLetter: "رسالة ترحيبية",
    photo: "صورة",
    cardFront: "مقدمة البطاقة",
    cardBack: "خلفية البطاقة",
    mailSignature: "توقيع البريد",
    assetNoData: "لا توجد بيانات لهذا المصدر",
    classNoData: "لا توجد بيانات لهذه الفئة"
  },
  accountDeletion: {
    accountDelete: "إلغاء الحساب",
    accountDeleteSuccess: "تم إلغاء تنشيط الحساب بنجاح",
    label1: "مسائل تعديل المعلومات",
    label2: "قضايا أخرى",
    issue1: "غير قادر على تغيير اسم الحساب",
    issue2: "مسائل الائتمان عبر الهاتف المحمول",
    issue3: "تغيير البريد الإلكتروني",
    issue4: "حساب مكرر",
    issue99: "قضايا المدخلات",
    nextStep: "الخطوة التالية",
    error: "الرجاء تحديد مشكلة",
    termsText: "لقد قرأت 《التذكيرات الهامة لإلغاء الحساب》 وأوافق عليها"
  },
  aboutUs: {
    currentVersion: "الإصدار الحالي",
    updateVersion: "تحديث الإصدار"
  },
  checkWaybill: {
    platformOrder: "أمر المنصة",
    temuOrderNumber: "رقم الطلب TEMU",
    jobNumber: "رقم الوظيفة",
    mainWbNumber: "سند الشحن الرئيسي",
    sideWbNumber: "سند الشحن الداخلي",
    shippingDate: "تاريخ الشحن",
    type: "النوع",
    goodState: "حالة الحمولة",
    warehouse: "مستودع",
    driver: "السائق",
    vehicle: "المركبة",
    paymentStatus: "حالة الدفع",
    deliveryCustomer: "اسم الشاحن",
    receiveCustomer: "اسم المستلم",
    receiveCountry: "دولة الاستلام",
    bulkUpdate: "تعديل الحالة بالدفعة",
    fileList: " قائمة الملفات ",
    export1: "صادر",
    export2: "وارد",
    addWbNumber: "إضافة رقم بوليصة الشحن الرئيسية",
    repeatBill: "لا تحدد رقم بوليصة شحن رئيسية موجودة",
    selectSingle: "الرجاء اختيار رقم بيان طريق رئيسي واحد",
    noWbNumber: "لم تتم إضافة رقم شهادة الطريق الرئيسية لهذه الشهادة بعد",
    editWbNumber: "تعديل رقم السند الرئيسي",
    viewWbNumber: "عرض رقم الفاتورة الرئيسية",
    deleteWbNumber: "احذف بيان الشحن",
    addSuccess: "تم الإضافة بنجاح",
    editSuccess: "تم التعديل بنجاح",
    searchText: "بحث عن رقم وثيقة الطريق",
    deliveryPhone: "رقم هاتف الشاحن",
    receivePhone: "رقم هاتف المرسل",
    createTime: "زمن الشحن",
    goodsName: "إسم المنتج",
    weight: "الوزن",
    pNumber: "الكمية",
    added: "أضيفت",
    notAdded: "غير مضاف",
    preAlertTitle: "ملفات التنبيه المسبق",
    mainNoButton: "رقم ملفات بوليصة الشحن الجوي الاصلية",
    dialogBillTitle: "خيارات الطباعة (اختياري)",
    isLogo: "عرض مشروع لوجو",
    isName: "عرض الاسم الإنجليزي للإنتربرايز",
    isDraft: "مسودة العلامة المائية",
    isTelexRelease: "إصدار التلكس",
    isOriginal: "أصلي",
    dialogWarehouseTitle: "سيتم تسليم البضائع إلى المستودع التالي",
    warehouseNameOrNumber: "اسم أو رقم المستودع",
    warehouseOwnership: "ملكية المستودع",
    warehouseList: "قائمة المخازن",
    sheet1: "إشعار مدين",
    sheet2: "تكاليف المورد",
    sheet3: "اختر المستودع",
    sheet4: "معاينة سند الشحن",
    sheet5: "الورقة الأمامية",
    sheet6: "إخطار الوصول / أمر العمل",
    preAlertNotice: "تحقق من رقم العمل لنفس رقم سند الشحن الرئيسي",
    cargoNotice: "يرجى تحديد بوليصة الشحن أولاً",
    expressWarehouse: "التخزين السريع للبضائع",
    mawbNumber: "عدد الصناديق الكبيرة",
    dialogSheetTitle: "خيارات الطباعة",
    isPrintVtrackLabel1: "ملصق توزيع مطبوع",
    isPrintVtrackLabel2: "ملصق مسار مطبوع"
  },
  billsReceivable: {
    project: "مشروع ",
    quantity: "الكمية",
    unitPrice: "سعر الوحدة",
    total: "الإجمالي",
    bankAccount: "الحساب البنكي",
    accountName: "إسم الحساب",
    bankName: "اسم البنك",
    address: "عنوان",
    remark: "ملاحظة",
    emailShare: "مشاركة البريد الإلكتروني",
    email: "بريد خدمة العملاء",
    placeholderEmail: "أدخل عناوين البريد الإلكتروني متعددة مفصولة بـ ','",
    selectBill: "يرجى اختيار الدفع",
    noAccount: "لا حساب بنكي"
  },
  supplierCostEntry: {
    title: "تفاصيل معلومات التكلفة",
    customName: "اسم العميل",
    customerNumber: "رقم العميل",
    quantity: "الكمية",
    unitPrice: "سعر الوحدة",
    total: "الإجمالي",
    referNo: "رقم مرجع فاتورة المورد",
    attachments: "المرفقات",
    taxInvoice: "فاتورة ضريبية",
    remark: "ملاحظة",
    amount: "الإجمالي",
  },
  logisticsStatus: {
    serialNumber: "الرقم التسلسلي",
    logisticsCn: "حالة اللوجستيات / المحلية",
    logisticsEn: "حالة اللوجستيات / الإنجليزية",
    logisticsSn: "اختصار حالة اللوجستيات",
    addState: "إضافة حالة لوجستية",
    editState: "تحرير حالة لوجستية",
    stateCn: "وصف حالة اللوجستيات / المحلية",
    stateEn: "وصف حالة اللوجستيات / الإنجليزية",
    sortNumber: "رقم الترتيب",
    add: "إنشاء",
  },
  jobSummary: {
    searchText: "رقم بيان السيّد/البيت",
    mainWbNumber: "بوليصة اصلية",
    sideWbNumber: "بوليصة داخلية",
    kefu: "خدمة العملاء",
    marketing: "التسويق",
    sales: "المبيعات",
    operation: "العملية",
    tradeTitle: "اللوجستيات التجارية",
    deliveryPort: "ميناء المغادرة",
    destinationPort: "ميناء الوصول",
    costTitle: "تفاصيل التكلفة",
    financialAccountNo: "رقم المرجع المالي",
    customerNumber: "رقم العميل",
    customName: "اسم العميل",
    billReferNo: "رقم مرجع فاتورة المورد",
    totalPayable: "إجمالي المبلغ المدفوع",
    totalPayableBalance: "الرصيد المستحق الدفع",
    viewCost: "عرض التكلفة",
    deleteCost: "حذف التكلفة",
    subTotal: "المجموع الفرعي",
    rate: "سعر الصرف",
    totalAmount: "الإجمالي",
    sellTitle: "تفاصيل البيع",
    invoiceNo: "فاتورة الخصم",
    customerNo: "رقم العميل",
    totalReceive: "إجمالي المبلغ المستحق",
    totalReceiveBalance: "الرصيد القابل للاسترداد",
    viewSell: "عرض البيع",
    deleteSell: "احذف البيع",
    receTotalAmount: "المبلغ الإجمالي",
    profitTotalAmount: "المبلغ الإجمالي",
    unloadText: "الرجاء إدخال السيد بي/ل أو المنزل بي/ل للبحث",
    notice: "إشعار",
    deleteCheck1: "هل أنت متأكد من حذف هذه التكلفة؟",
    deleteCheck2: "هل أنت متأكد من حذف هذا البيع؟",
  },
  orderWayBill: {
    sopNumber: "رقم SOP",
    companyNameSn: "اختصار العميل",
    customerNumber: "رقم العميل",
    businessType: "أنواع الأعمال",
    deliveryCity: "مدينة التسليم",
    destinationCity: "مدينة الوجهة",
    salesUsername: "المبيعات",
    createTime: "إنشاء وقت",
    sales: "المبيعات",
    pNumber: "الكمية",
    volume: "الحجم",
    weight: "الوزن",
    goodsName: "اسم البضاعة",
    orderState: "حالة الطلب",
    generate: "توليد رقم سند الشحن",
  },
  goodsFiles: {
    sopNumber: "رقم SOP",
    sideWbNumber: "بوليصة الشحن الفرعية",
    companyNameSn: "اختصار العميل",
    customerNumber: "رقم العميل",
    businessType: "أنواع الأعمال",
    deliveryCity: "مدينة التسليم",
    destinationCity: "مدينة الوجهة",
    createTime: "إنشاء وقت",
    erNumber: "رقم المرجع الموثوق",
    date: "التاريخ",
    commission: "حجز إلكتروني",
    contract: "عقد",
    quotation: "عرض سعر",
    supplier: "المورد",
    emailAddress: "عنوان البريد الإلكتروني",
    warehouseNumber: "رقم المستودع",
    supplierPhone: "رقم جوال المورد",
    invoice: "فاتورة",
    packingList: "قائمة التعبئة",
    noticeBill: "فاتورة إشعار التخزين",
    fileList: "قائمة الملفات",
    emailShare: "مشاركة البريد الإلكتروني",
    unupload: "لم يتم الرفع بعد",
    clickShare: "اضغط على لمشاركة",
    goodsFiles: "قائمة الشحن",
    saveButton: "حفظ مستندات البضائع",
    viewFile: "عرض الملف",
    supplierFileList: "قائمة ملفات الموردين",
    sendInvite: "إرسال دعوة",
    placeholderEmail: "أدخل عدة عناوين بريد إلكتروني مفصولة بـ ','",
  },
  preAlert: {
    mainWbNumber: "البوليصة الرئيسية",
    sideWbNumber: "البوليصة الفرعية",
    businessType: "أنواع الأعمال",
    deliveryCity: "مدينة التسليم",
    destinationCity: "مدينة الوجهة",
    status: "الحالة",
    state1: " غير مؤكد ",
    state2: "تم التأكيد ",
    flightNumber: "رقم الرحلة",
    shipmentPortAgent: "وكيل ميناء الشحن ",
    destinationAgent: "وكيل الوجهة ",
    dateType: "نوع التاريخ",
    receiptDate: "تاريخ الاستلام ",
    tab1: "تم استلام",
    tab2: "أُرسلت",
    totalHawb: "المجموع الكلي لبوالص الشحن الجوي",
    transitshipment: " شحنة عابرة؟",
    totalNumber: "إجمالي عدد العبوات",
    weight: "الوزن الإجمالي",
    volume: "الحجم ",
    etd: "الوقت المقدر للمغادرة",
    atd: "الوقت الفعلي للمغادرة",
    eta: "الوقت المقدر للوصول ",
    ata: "وقت الوصول الفعلي ",
    remark: "ملاحظة ",
    log: "سجلات العمليات ",
    operator: " المشغل ",
    date: "التاريخ",
    mail: "المستلم المرسل إليه البريد",
    push: "ارسال تحديثات تتبع الشحنة",
    companyLogo: "شعار الشركة",
    companyName: "اسم الشركة",
    companyCode: "رمز الشركة",
    companyUser: "مستخدم مؤسسي",
    cargoType: "نوع الحمولة",
    total: "الإجمالي",
    others: "وثائق أخرى",
    remarkPlaceHolder:
      "Cargo Handling Remark ( ستتم طباعة الجزء الرئيسي فقط بدون وضع علامة)",
    printRemark: "ملاحظة مطبوعة",
    detailList: "قائمة أوامر العمل",
    button1: "الدفع الداخلي VTRACK",
    button2: "إرسال بريد إلكتروني",
    email: "بريد خدمة العملاء",
    placeholderEmail: "أدخل عناوين البريد الإلكتروني متعددة مفصولة بـ ','",
    preAlertTitle: "ملفات التنبيه المسبق",
    emailLabel: "الرجاء تحديد الملف الذي تريد إرساله",
    file1: "البوليصة الفرعية",
    file2: "إشعار الوصول",
    workSheet: "إنشاء أمر عمل",
    noticeText: "هل تريد إصدار أمر دخول المستودع؟"
  },
  basicInfo: {
    companyName: "اسم الشركة",
    companyNameEn: "اسم الشركة باللغة الإنجليزية",
    companyNameSn: "اختصار العميل",
    companyAddress: "عنوان الشركة",
    companyCode: "رمز الشركة المرتبطة",
    legalPerson: "الشخص القانوني للشركة",
    telePhone: "الهاتف الثابت",
    webSite: "موقع المؤسسة الإلكتروني",
    personalID: "رقم هوية العميل",
    personalPassport: "رقم جواز سفر العميل",
    customerNumber: "رقم العميل",
    customerPhone: "رقم الهاتف المحمول",
    customerPassword: "كلمة مرور العميل",
    businessLicence: "رخصة أعمال",
    area: "المنطقة",
    receivable: "الرصيد",
    status: "الحالة",
    operationInfo: "تعليمات العملية",
    addPeople: "تم الإضافة بواسطة",
    referrer: "المُحيل",
    addButton: "إنشاء عميل",
    refer: "مرجع بواسطة",
    password: "كلمة المرور",
    createDate: "تاريخ الإنشاء",
    createdBy: "تم إنشاء بواسطة",
    cityName: "المدينة",
    addAgentButton: "إنشاء وكيل",
    phoneNumber: "رقم الهاتف",
    contact: "الاتصال",
    email: "بريد الإلكتروني",
    address: "العنوان",
    notes: "ملاحظات",
    createType: "نوع حساب العميل",
    createType1: "حساب vTrack",
    createType2: "حساب التعبير",
    createType3: "حساب TEMU التعبيري",
    createType4: "حساب المستلم المُعبَّر عنه",
  },
  bankAccount: {
    searchText: "البحث عن رقم العميل",
    customerNumber: "رقم العميل",
    customerName: "اسم العميل",
    currency: "العملة",
    accountName: "اسم الحساب",
    bankNumber: "رمز سويفت",
    status: "الحالة",
    accountState: "حالة الحساب",
    addButton: "إنشاء حساب",
    bankName: "اسم البنك ",
    bankRegion: "منطقة البنك",
    bankAddress: "عنوان البنك",
    companyAddressEn: "عنوان الشركة باللغة الإنجليزية",
    enterpriseId: "رقم التعريف الضريبي",
    clerk: "موظف الإدخال",
    none: "رقم العميل هذا غير موجود"
  },
  contactStaff: {
    customerNumber: "رقم العميل",
    contact: "شخص الاتصال",
    customerPhone: "رقم الهاتف المحمول",
    addButton: "إنشاء جهة اتصال",
    email: "البريد الإلكتروني ",
    qqNumber: "رقم QQ",
    wechat: "WeChat",
    telePhoneNumber: "رقم الهاتف",
    liaison: "حلقة الاتصال",
  },
  contractManagement: {
    contractNumber: "رقم العقد",
    contractName: "اسم العقد",
    customerShort: "الاسم المختصر للعميل",
    validityDate: "مدة الصلاحية",
    creditLimit: "حد الائتمان",
    customerNumber: "رقم العميل",
    addButton: "إنشاء عقد",
    conclusion: "خاتمة العقد",
    dIssueBy: "صادر عن",
    validity: "تاريخ الصلاحية",
    creditDays: "أيام الائتمان",
    attachmentList: "قائمة المرفقات",
    creditAmount: "مبلغ الائتمان",
  },
  receivingAccountManagement: {
    searchText: "البحث عن اسم الحساب",
    accountNickName: "اسم مستعار للحساب",
    accountName: "اسم الحساب",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    status: "الحالة",
    accountState: "حالة الحساب",
    addButton: "إنشاء حساب",
    address: "عنوان المؤسسة",
    remark: "ملاحظة",
    accountCollectionType: "نوع جمع الحساب",
    collectionType1: "Alipay",
    collectionType2: "Wechat",
    collectionType3: "FLYPAY",
    collectionType5: "رسوم التوصيل",
  },
  expenseNameManagement: {
    searchText: "مشروع دفع البحث",
    paymentProject: "اسم العنصر / الموقع",
    paymentProjectEn: "اسم العنصر / الإنجليزية",
    addButton: "إنشاء مشروع دفع",
  },
  exchangeRateInfo: {
    currency: "العملة",
    rate: "سعر الصرف",
    time: "الوقت",
    addButton: "إنشاء معدل",
    searchText: "عملة البحث",
    log: "سجل العمليات",
    content: "محتوى العملية",
    username: "المشغل",
    createTime: "وقت العملية",
  },
  invoiceItemList: {
    searchText: "بحث عن اسم المشروع",
    itemName: "اسم العنصر / الموقع",
    itemNameEn: "اسم العنصر / الإنجليزية",
    addButton: "إنشاء عنصر فاتورة",
  },
  reportQuerySummary: {
    mainWbNumber: "بوليصة الشحن الرئيسية",
    sideWbNumber: "بوليصة الشحن الفرعية",
    financialAccountNo: "رقم فاتورة التكلفة",
    deliveryPort: "ميناء المغادرة",
    destinationPort: "ميناء الوصول",
    invoiceNo: "رقم الفاتورة.",
    createDate: "تاريخ الفاتورة",
    total: "إجمالي الفاتورة",
    payerName1: "اسم الدافع",
    payerName2: "اسم الدافع",
    recommend: "المحيل",
    wbNumber: "رقم بوليصة الشحن",
    warehouseWorkNumber: " رقم وظيفة المستودع",
    jobNumber: "رقم الوظيفة",
    customerNumber: "رقم العميل",
    companyName: "اسم الشركة",
    dataOtion0: "ابحث برقم الفاتورة",
    dataOtion1: "البحث حسب وظيفة اللوجستيات",
    dataOtion2: "البحث حسب وظيفة التخزين",
    dataOtion3: "البحث حسب طلب التجارة",
    bill: "إنشاء طلب دفع",
    tab1: "قائمة المدفوعات المستحقة",
    tab2: "قائمة المدفوعات المستحقة الدفع",
    tradeTitle: "اللوجستيات التجارية",
    atd: "ATD",
    amountTitle: "قيمة التداول",
    outStandingDays: "عدد الأيام المستحقة",
    creditBalance: "رصيد المبلغ الائتماني",
    balance: "الرصيد المستحق",
    totalBalance: "إجمالي الرصيد المستحق",
    rate: "سعر",
    taxInvoice: "فاتورة ضريبية",
    invoiceNumber: "رقم طلب الفاتورة",
    invoiceFile: "ملف الفاتورة الضريبية",
    billDetail: "تفاصيل رقم الفاتورة",
    viewCost: "عرض التكلفة",
    payrollRequest: "طلب الرواتب",
    subTotal: "المجموع الفرعي",
    unreceiveTotal: "إجمالي المبلغ المستحق",
    totalPayableBalance: "رصيد مُستحق إجماليًا",
  },
  payrollDetails: {
    title1: "طلب الدفع ",
    title2: "معلومات تجميع الموردين ",
    title3: "الحساب ",
    title4: "رقم طلب عمل الدفع ",
    title5: "عملية الموافقة ",
    companyLogo: "شعار الشركة",
    companyName: "اسم الشركة",
    applyDate: "تاريخ التقديم ",
    paymentRecordNumber: "رقم سجل الدفع",
    voucherNumber: "رقم القسيمة",
    lastDate: "آخر تاريخ للدفع",
    remark: "ملاحظة",
    supplierCode: "رمز المورد",
    supplierName: "اسم المورد",
    addAccount: "إضافة حساب",
    addSuccess: "تم الإضافة بنجاح",
    bankName: "اسم البنك ",
    accountNo: "رقم الحساب",
    bankAccount: "الحساب البنكي",
    accountDetail: "تفاصيل الحساب",
    accountCurrency: "عملة الحساب",
    bankRegion: "منطقة البنك",
    bankAddress: "عنوان البنك",
    addressEn: "العنوان الإنجليزي للمنشأة",
    enterpriseId: "رقم تسجيل المنشأة",
    financialAccountNo: "رقم المرجع المالي",
    workNumber: "رقم العمل ",
    payAmount: "مبلغ الدفع",
    requestCount: "عدد الطلبات",
    collection: "حالة التحصيل",
    receivedTotal: "إجمالي المبلغ المستلم",
    paidTotal: "إجمالي المبلغ المدفوع",
    profitAmount: "إجمالي مبلغ الربح",
    totalcreditAmount: "إجمالي مبلغ الائتمان",
    profitPercent: "نسبة الربح",
    paymentCurrency: "طلب العملة ",
    requestAmount: "المبلغ المطلوب",
    position: "منصب",
    username: "اسم المستخدم",
    approvalState: "حالة الموافقة ",
    aState1: "إلغاء التطبيق ",
    aState2: "في انتظار الموافقة ",
    aState3: "موافق",
    aState4: "غير موافق",
    approvalResult: "نتيجة الموافقة ",
    approvalUser: "اسم المستخدم المعتمد ",
    opinions: "الآراء المعتمدة ",
    auditTime: "وقت التدقيق ",
    approvalOperate: "الموافقة على التشغيل",
    agree: "موافق",
    disagree: "غير موافق",
    resubmit: "إعادة الإرسال",
    saveChange: "احفظ هذا التغيير",
    tSave: "حفظ مؤقت",
    cancelApply: "إلغاء هذا التطبيق",
  },
  payrollList: {
    position: "المنصب",
    type: "نوع الطلب: التشغيل",
    paymentRecordNumber: "رقم سجل الدفع",
    applicant: "مقدم الطلب",
    department: "القسم",
    submitTime: "وقت التقديم",
    submitCount: "إرسال العدد",
    currency: "العملة",
    costAmount: "مبلغ المصاريف",
    menthodState: "طريقة الدفع",
    mState1: "نقداً",
    mState2: "محفظة إلكترونية",
    mState3: "تحويل بنكي",
    approvalState: "حالة الموافقة",
    aState1: "في انتظار الموافقة",
    aState2: "مكتمل",
    aState3: "ملغي",
    aState4: "مرفوض",
    aState5: "الموافقة مكتملة",
    paymentState: "حالة الدفع",
    pState1: "غير مدفوع",
    pState2: "مدفوع",
    systemCode: "رقم قسيمة الدفع",
    totalBatch: "إجمالي الدفعة",
    uploadDate: "تاريخ رفع الشهادة",
    button1: "مراجعة الحسابات",
    button2: "الأجور",
    button3: "تحرير تشغيل طلب الدفع",
    button4: "طلب التفاصيل",
    button5: "طلب التشغيل",
    paymentTitle: "الرجاء تحميل قسيمة الدفع",
    payReceipt: "إيصال الدفع",
  },
  profitableList: {
    mainWbNumber: "بوليصة شحن اصلية",
    sideWbNumber: "بوليصة شحن داخلية",
    wbNumber: "رقم بوليصة الشحن",
    warehouseWorkNumber: "رقم وظيفة المستودع",
    invoiceNo: "رقم الفاتورة.",
    companyName: "اسم الشركة",
    userType: "نوع المستخدم",
    usType1: "مشغل",
    usType2: "مبيعات",
    usType3: "خدمة",
    usType4: "سوق",
    jobNumber: "رقم الوظيفة",
    dataOtion0: "ابحث برقم الفاتورة",
    dataOtion1: "البحث حسب وظيفة اللوجستيات",
    dataOtion2: "البحث حسب وظيفة التخزين",
    dataOtion3: "البحث حسب طلب التجارة",
    refer: "مرجع بواسطة",
    tradeTitle: "اللوجستيات التجارية",
    deliveryPort: "ميناء المغادرة",
    destinationPort: "ميناء الوصول",
    atd: "ATD",
    amountDetail: "تفاصيل المبلغ",
    receivedTotal: "إجمالي المبلغ المستلم",
    receivedAmount: "المبلغ المستحق",
    paidTotal: "إجمالي المبلغ المدفوع",
    payAmount: "مبلغ الدفع ",
    subProfit: "الربح الفرعي",
    rate: "سعر الصرف",
    received: "إجمالي المبلغ المستلم",
    paid: "إجمالي المبلغ المدفوع",
    profits: "إجمالي الربح",
  },
  finishedCheckBillsSummary: {
    nuclearAccountNo: "سجل حساب المعالجة",
    creditDate: "تاريخ الاعتماد",
    customerName: "اسم العميل",
    nuclearType: "نوع حساب النواة",
    wbNumber: "رقم بوليصة الشحن الرئيسية أو الفرعية",
    customerNumber: "رقم العميل",
    companyName: "اسم الشركة",
    nuType1: "مستحقات",
    nuType2: "مدفوعات",
    nuType3: "رصيد",
    all: "الكل",
    dataOtion1: "البحث حسب وظيفة اللوجستيات",
    dataOtion2: "البحث حسب وظيفة التخزين",
    bank: "البنك المعني",
    nuclearTitle: "الملكية النووية",
    receivableAmount: "المبلغ المستلم",
    creditAmount: "مبلغ الائتمان",
    details: "التفاصيل",
    payReceipt: "إيصال الدفع",
    warehouseWorkNumber: "رقم وظيفة المستودع",
    workOrderNumber: "رقم أمر العمل"
  },
  taxInvoice: {
    title: "فاتورة ضريبية",
    mainWbNumber: "بوليصة الشحن الرئيسية",
    sideWbNumber: "بوليصة الشحن الفرعية",
    wbNumber: "رقم بوليصة الشحن الرئيسية أو الفرعية",
    invoiceNo: "رقم الفاتورة.",
    billDate: "تاريخ الفاتورة",
    payerName1: "اسم الدافع",
    payerName2: "اسم الدافع",
    invoiceAmount: "إجمالي مبلغ الفاتورة",
    invoiceTotal: "إجمالي الفاتورة الفرعية",
    invoiceAmountSn: "مبلغ الفاتورة",
    invoiceType: "نوع الفاتورة",
    invoiceType1: "فاتورة كاملة",
    invoiceType2: "جزء من الفاتورة",
    invoiceNumber: "رقم الفاتورة الضريبية",
    applyDate: "تاريخ التقديم ",
    invoiceDate: "تاريخ التقديم",
    issuedDate: "تاريخ الإصدار",
    warehouseWorkNumber: "رقم وظيفة المستودع",
    customerNumber: "رقم العميل",
    companyName: "اسم الشركة",
    recommend: "المرجع",
    all: "الكل",
    dataOtion1: "البحث حسب وظيفة اللوجستيات",
    dataOtion2: "البحث حسب وظيفة التخزين",
    invoiceItem: "بند الفاتورة",
    remark: "ملاحظات",
    tab1: "قائمة الانتظار",
    tab2: "قائمة المقدمات",
    tab3: "قائمة الفواتير",
    applyInvoice: "تطبيق الفاتورة كاملة",
    applyHalfInvoice: "تطبيق جزء من الفاتورة",
    refundApplyInvoice: "إلغاء الفاتورة الضريبية",
    refundInvoice: "استرداد الفاتورة",
    tradeTitle: "اللوجستيات التجارية",
    deliveryPort: "ميناء الشحن",
    destinationPort: "ميناء الوصول",
    atd: "تاريخ الشحن",
    amountTitle: "قيمة التداول",
    itemName: "اسم العنصر",
    applicant: "مقدم الطلب للفاتورة",
    bankAccountInfo: "معلومات الحساب البنكي",
    currency: "العملة",
    accountName: "إسم الحساب",
    bankName: "المدفوع له",
    bankRegion: "منطقة البنك",
    bankNumber: "رمز سويفت",
    bankAddress: "عنوان البنك",
    companyAddressEn: "عنوان الشركة باللغة الإنجليزية",
    enterpriseId: "رقم تسجيل المنشأة",
    telephone: "رقم الهاتف التجاري",
    address: "عنوان العمل",
    viewInvoice: "عرض فاتورة الضريبة",
    uploadinvoice: "رفع الفاتورة الضريبية",
    emailAddress: "عنوان البريد الإلكتروني",
    invoiceShare: "مشاركة الفاتورة",
    billDetail: "تفاصيل رقم الفاتورة",
    addInvoice: "إضافة فاتورة ضريبة",
    invoiceFile: "ملف الفاتورة الضريبية",
  },
  payrollRequest: {
    title: "طلب النفقات ",
    costCate: "فئة النفقات ",
    startDate: "تاريخ البدء ",
    to: "إلى ",
    endDate: "تاريخ الانتهاء ",
    time: "الوقت",
    paymentAddress: "عنوان النفقات",
    instructions: "بيان النفقات ",
    feeAmount: "مبلغ النفقات",
    voucherNumber: "رقم القسيمة",
    requestReceipt: "طلب الإيصال",
    userList: "التعاون مع",
    isBudget: "نفقات الميزانية",
    recipient: "طريقة الاستلام",
    mState1: "نقداً",
    mState2: "المحفظة الإلكترونية",
    mState3: "تحويل بنكي",
    qrcode: "كود الاستجابة السريعة",
    myBankAccount: "رقم حسابي البنكي ",
    bankInfo: "معلومات الحساب البنكي",
    bankAccount: "الحساب البنكي",
    bankName: "اسم البنك",
    processList: "عملية الموافقة",
    position: "المنصب",
    username: "اسم المستخدم",
    approvalState: "حالة الموافقة ",
    aState1: "لا تنطبق",
    aState2: "في انتظار الموافقة",
    aState3: "موافق ",
    aState4: "غير موافق",
    approvalResult: "نتيجة الموافقة",
    approvalUser: "اسم المستخدم المعتمد",
    opinions: "الآراء المعتمدة",
    auditTime: "وقت التدقيق",
    approvalOperate: "الموافقة على التشغيل",
    agree: "موافق",
    disagree: "غير موافق",
    resubmit: "إعادة الإرسال",
    saveChange: "احفظ هذا التغيير",
    cancelApply: "إلغاء هذا التطبيق",
  },
  financialRequest: {
    paymentRecordNumber: "رقم سجل الدفع",
    approvalState: "حالة الموافقة",
    totalBatch: "إجمالي الدفعة",
    aState1: "في انتظار الموافقة",
    aState2: "مكتمل",
    aState3: "إلغاء",
    aState4: "رفض",
    aState5: "اكتملت الموافقة",
    menthodState: "طريقة الدفع",
    mState1: "نقداً",
    mState2: "المحفظة الإلكترونية",
    mState3: "التحويل البنكي",
    paymentState: "حالة الدفع",
    pState1: "غير مدفوعة",
    pState2: "مدفوعة الأجر",
    supplierName: "اسم المورد",
    voucherNumber: "رقم القسيمة",
    recordNumber: "طلب رقم السجل",
    applicant: "مقدم الطلب",
    department: "القسم",
    systemCode: "رقم قسيمة الدفع",
    creditRefNo: "رقم المرجع الائتماني",
    costCode: "رقم قسيمة التكلفة",
    submitDate: "تاريخ التقديم",
    lastDate: "تاريخ آخر دفعة",
    uploadDate: "تاريخ تحميل الشهادة",
    tab1: "الأعمال التجارية",
    tab2: "تشغيل ",
    dTitle1: "معلومات المورّد والدفع",
    dTitle2: "معلومات التكلفة",
    requestReceipt: "طلب الإيصال",
    payAmount: "مبلغ الدفع",
    payReceipt: "إيصال الدفع",
    submitTime: "وقت التقديم",
    submitCount: "إرسال العدد",
    costAmount: "مبلغ المصاريف",
    costCode: "رقم قسيمة التكلفة",
    button1: "تحرير طلب دفع العمل",
    button2: "تحرير تشغيل طلب الدفع",
    button3: "الموافقة على أموال الأعمال التجارية",
    button4: "الموافقة على الأموال التشغيلية",
    button5: "عرض طلب دفع العمل",
    button6: "عرض طلب دفع تشغيل",
    payButton: "إدفع الآن",
    txtButton: "الرجاء فتح www.vtrack.top لإتمام الدفع",
    position: "المنصب",
    viewButton: "عرض طلب الدفع"
  },
  paymentInvoice: {
    companyName: "اسم الشركة ",
    payInvoiceNo: "رقم فاتورة الدفع.",
    mainWbNumber: "بوليصة اصلية",
    sideWbNumber: "بوليصة داخلية",
    warehouseWorkNumber: " رقم وظيفة المستودع",
    createTime: "إنشاء وقت",
    invoiceState: "حالة الفاتورة ",
    state1: "الكل",
    state2: "غير مؤكد",
    state3: "تم التأكيد",
    submit: "تأكيد الفاتورة",
    invoiceNo: "رقم الفاتورة.",
  },
  creditedDetails: {
    invoiceNo: "رقم الفاتورة.",
    financialAccountNo: "رقم المرجع المالي",
    mainWbNumber: "بوليصة اصلية",
    sideWbNumber: "بوليصة داخلية",
    warehouseWorkNumber: " رقم وظيفة المستودع",
    customerName: "رقم العميل",
    createDate: "تاريخ الإنشاء",
    nuclearTitle: "الملكية النووية",
    receivableAmount: "المبلغ المستلم",
    payableAmount: "المبلغ المدفوع",
    verifyAmount: "المبلغ الائتماني",
    blance: "رصيد الفواتير",
    billDetail: "تفاصيل رقم الفاتورة",
    viewCost: "عرض التكلفة",
    workOrderNumber: "رقم أمر العمل"
  },
  cargoStatistics: {
    country: "البلد",
    destinationCity: "مدينة الوجهة",
    jobs: "عدد الوظائف",
    totalValue: "إجمالي الحجم",
    totalWeight: "إجمالي الوزن الصافي",
    totalCost: "إجمالي التكلفة",
    totalSell: "إجمالي المبيعات",
    totalProfit: "إجمالي الربح",
    profitPercent: "نسبة الربح",
  },
  lineChartStatistics: {
    cityName: "المدينة",
    year: "",
    currency: "العملة",
    month: "الشهر",
    jobs: "عدد الوظائف",
    totalValue: "إجمالي الحجم",
    totalWeight: "إجمالي الوزن الصافي",
    airPrice: "متوسط سعر الشحن الجوي",
    price20: "متوسط سعر 20'",
    price40: "متوسط سعر 40'",
    price40HQ: "متوسط سعر 40' HQ",
    priceOther: "متوسط سعر أخرى",
    selectYear: "اختر سنة",
    line1: "خط سعر التكلفة",
    line2: "خط سعر البيع",
    line3: "المبيعات",
  },
  expenseStatistics: {
    project: "مشروع",
    year: "سنة",
    totalCost: "إجمالي التكلفة",
    itemName: "اسم العنصر",
    parentName: "الفئة الرئيسية",
    subName: "الفئة الفرعية",
    amount: "المبلغ",
    currencySn: "العملة",
    parentNameProportion: "نسبة الإنفاق للفئة الرئيسية",
    monthTitle: "الإنفاق الشهري",
    monthTotal: "مجموع النفقات الشهرية",
    selectYear: "اختر سنة",
    selectMonth: "اختر شهراً",
    month: "الشهر",
    monthSn: "الشهر",
    month1: "يناير",
    month2: "فبراير",
    month3: "مارس",
    month4: "أبريل",
    month5: "مايو",
    month6: "يونيو",
    month7: "يوليو",
    month8: "أغسطس",
    month9: "سبتمبر",
    month10: "أكتوبر",
    month11: "نوفمبر",
    month12: "ديسمبر",
    paymentRecordNumber: "رقم سجل الدفع",
    category: "فئة المصاريف الفرعية",
    applicant: "المتقدم",
    department: "القسم",
    submitTime: "وقت التقديم",
    submitCount: "عدد التقديمات",
    submitDate: "تاريخ التقديم",
    currency: "العملة",
    feeAmount: "مبلغ النفقات",
    costCode: "رقم قسيمة التكاليف",
    menthodState: "طريقة الدفع",
    mState1: "نقداً",
    mState2: "محفظة إلكترونية",
    mState3: "تحويل بنكي",
    approvalState: "حالة الموافقة",
    aState1: "في انتظار الموافقة",
    aState2: "مكتمل",
    aState3: "ملغي",
    aState4: "مرفوض",
    aState5: "الموافقة مكتملة",
    paymentState: "حالة الدفع",
    pState1: "غير مدفوع",
    pState2: "مدفوع",
    systemCode: "رقم قسيمة الدفع",
    totalBatch: "إجمالي الدفعة",
    uploadDate: "تاريخ رفع الشهادة",
    requestReceipt: "إيصال الطلب",
    payReceipt: "إيصال الدفع",
    fileList: "قائمة الملفات",
  },
  customerBusinessStatistics: {
    customerNumber: "رقم العميل",
    companyName: "اسم الشركة",
    totalVotes: "إجمالي الأصوات",
    tab1: "قائمة مدفوعات العملاء",
    tab2: "قائمة تحصيلات العملاء",
    airTotalVotes: "إجمالي الأصوات الجوية",
    seaTotalVotes: "إجمالي الأصوات البحرية",
    expressTotalVotes: "إجمالي الأصوات السريعة",
    warehouseTotalVotes: "إجمالي الأصوات في المستودع",
    amountTitle: "قيمة التداول",
    payAmount: "مبلغ الدفع",
    receivedAmount: "المبلغ المستحق",
    amount: "الإجمالي",
    button1: "تفاصيل دفع العميل",
    button2: "تفاصيل مجموعة العملاء",
    mainWbNumber: "رقم بوليصة الشحن الرئيسية",
    sideWbNumber: "رقم بوليصة الشحن الفرعية",
    invoiceNo: "رقم الفاتورة",
    financialAccountNo: "رقم المرجع المالي",
    warehouseWorkNumber: "رقم عمل المستودع",
    createDate: "تاريخ الفاتورة",
    paidTotal: "إجمالي المبلغ المدفوع",
    receivedTotal: "إجمالي المبلغ المستلم",
  },
  seaFreightDataStatistics: {
    tab1: "إحصاءات الفواتير الشهرية",
    tab2: "الاستعلام عن منفذ الحمولة",
    month: "الشهر",
    wayBillCount: "سند الشحن إجمالي الأصوات الشهرية",
    costBillCount: "العدد الإجمالي للأصوات في شهر الفوترة",
    mainWbNumber: "بوليصة اصلية",
    sideWbNumber: "بوليصة داخلية",
    deliveryPort: "ميناء المغادرة",
    destinationPort: "ميناء الوصول",
    deliveryCity: "مدينة التسليم ",
    receiveCity: "إستلم المدينة",
    receiveCountry: "بلد الاستلام",
    billName: "دفع الفواتير",
    date: "التاريخ",
    cabinet20: "20'",
    cabinet40: "40'",
    cabinet40HQ: "40'HQ",
    cabinetOthers: "Others",
    amountTitle: "قيمة التداول",
    payAmount: "مبلغ الدفع ",
    cabinetClass: "فئة نوع الخزانة",
    departureDate: "تاريخ الشحن",
    arrivalDate: "تاريخ الوصول",
    daysDifference: "أيام المرور العابر",
  },
  warehouse: {
    warehouseKeeper: "حارس مستودع",
    warehouseNameOrNumber: "اسم المستودع أو الرقم",
    warehouseNumber: "رمز المستودع",
    warehouseOwnership: "ملكية المستودع",
    warehouseName: "اسم المستودع",
    warehouseUseType: "نوع استخدام المستودع",
    warehouseAddress: "عنوان المستودع",
    warehouseContact1: "جهة الاتصال 1",
    warehouseContact2: "جهة الاتصال 2",
    warehouseStatus: "حالة المستودع",
    disableOption: "معطل",
    enableOption: "مفعل",
    ownerOption1: "مستودع مملوك ذاتيًا",
    ownerOption2: "مستودع فرعي",
    addButton1: "إنشاء مستودع",
    warehouseLogo: "شعار المستودع",
    warehousePhoto: "صور المستودع",
    warehouseTime: "وقت العمل",
    precaution: "احتياطات التخزين",
    warehousePhone: "رقم الاتصال",
    warehouseEmail: "بريد الاتصال",
    warehouseOption1: "نوع المستودع (خيار واحد)",
    warehouseOption2: "نوع المستودع (خيارات متعددة)",
    ties: "يمكن للمستودع الذاتي التشغيل ملء المعلومات التالية",
    isService: "الخدمات المفتوحة للجمهور",
    contact: "جهة الاتصال",
    phone: "الهاتف",
    photo: "صورة شخصية",
    startDate: "وقت البدء",
    endDate: "وقت الانتهاء",
    recordNumber: "رقم تسجيل إعداد النموذج",
    formName: "اسم النموذج",
    object: "موضوع النموذج",
    editTime: "وقت التعديل",
    editor: "آخر معدّل",
    formState: "حالة النموذج",
    nameOption1: "إشعار دخول المستودع",
    nameOption2: "مذكرة التسليم",
    remark: "ملاحظة",
    precaution: "لوائح المستودع",
    addButton2: "إنشاء إعدادات النموذج",
    displayContent: "محتوى العرض",
    outboundNumber: "رقم الصادرات",
    outBoundTime: "وقت الخروج",
    warehousingType: "نوع التخزين",
    warehouseWorkNumber: "رقم وظيفة المستودع",
    warehouseExportNumber: "رقم وظيفة الخروج",
    date: "التاريخ",
    warehouseCode: "رمز المستودع",
    goodsName: "اسم البضاعة",
    billEnterprise: "الطرف الفاتح",
    createTime: "وقت التخزين",
    operation: "عملية",
    boxName: "اسم الصندوق",
    size: "الحجم",
    goodsValue: "قيمة العنصر",
    outBoundState: "حالة الخروج",
    warehouseNumber: "رقم دخول المستودع",
    batch: "دفعة",
    InStorageTime: "وقت التخزين",
    warehousingTime: "وقت ETA",
    batchRefNumber: "رقم مرجع دفعة السلع",
    criteria: "اسم السلع/العلامة التجارية/الموديل",
    operateType: "نوع العملية",
    operation1: "تخزين",
    operation2: "خارج المستودع",
    operation3: "تغيير المستودع",
    addButton3: "إضافة طلب مستودع",
    tab1: "قيد التسليم",
    tab2: "البضائع في المستودع",
    tab3: "سجلات عمليات الشحن",
    tab4: "طلب الخروج",
    tab5: "خارج التخزين",
    pNumber: "عدد الطرود",
    volume: "الحجم",
    weight: "الوزن",
    piecesUnit: "وحدة تعبئة",
    storageArea: "منطقة التخزين",
    storageTime: "تاريخ التخزين",
    storageDays: "أيام التخزين",
    logBtn: "تفاصيل أكثر",
    goodsNameSn: "اسم المنتج",
    brand: "العلامة التجارية",
    model: "الموديل",
    exportNumber: "كمية الصادرات",
    inventory: "كمية المخزون",
    long: "الطول",
    width: "العرض",
    height: "الارتفاع",
    productImage: "صور المنتج",
    status: "الحالة",
    bContact: "جهة اتصال مهنية",
    bPhone: "رقم جهة اتصال العمل",
    expressTitle: "المعلومات الصريحة",
    expressCompany: "اسم شركة الشحن السريع",
    expressNumber: "رقم مرجع الشحن السريع",
    deliveryTitle: "معلومات التسليم",
    emergencyPerson: "مسؤول الاتصال في حالات الطوارئ",
    emergencyPhone: "رقم جهة اتصال الطوارئ",
    plate: "رقم لوحة السيارة",
    cargoTitle: "معلومات الحمولة",
    esPackage: "عدد العناصر المحجوزة للتخزين",
    esVolume: "حجم التخزين المحجوز",
    esWeight: "وزن الشحن المحجوز",
    adQuantity: "عدد الطلبات المقدمة",
    ata: "وقت الوصول الفعلي",
    incomingVolume: "حجم البضائع (المقياس التكعيبي)",
    incomingWeight: "وزن البضائع (بالكيلوغرام)",
    warehousingPhoto: "صورة للتخزين",
    arrive: "تأكيد الوصول",
    outbound: "تطبيق الصادر",
    viewApply: "تطبيق عرض",
    sheet1: "تحرير معلومات التسليم السريع",
    sheet2: "تحرير معلومات التسليم",
    sheet3: "حرّر أمر عمل المستودع",
    sheet4: "إشعار مدين",
    sheet5: "تكاليف المورد",
    sheet6: "تفاصيل طلبية",
    sheet7: "تفاصيل أمر العمل الصادر",
    entrustEnterprise: "مؤسسة التخزين الموثوق بها",
    customerNumber: "رقم العميل",
    productsName: "اسم البضاعة",
    warehouseSn: "مستودع",
    driverInfo: "معلومات السائق",
    driverName: "شخص الاتصال",
    driverPhone: "رقم هاتف الاتصال",
    driverPlate: "رقم لوحة السيارة",
    addProduct: "إنشاء حمولة",
    addProductFirst: "الرجاء إنشاء الحمولة أولاً",
    cargoName: "البضائع",
    productsNameSn: "اسم المنتج",
    unitPrice: "سعر الوحدة",
    quantity: "الكمية الإجمالية",
    surplus: "فائض",
    packingDetail: "تفاصيل التعبئة",
    pushButton: "إضافة ناتج",
    caseNumberSn: "رقم الكرتون",
    parentBox: "رقم الصندوق الرئيسي",
    caseNumber: "رقم الكرتون / رقم البالتة",
    packingQty: "كمية التعبئة",
    goodsDetail: "تفاصيل السلع",
    goodsValueTotal: "إجمالي قيمة العناصر",
    noImage: "لا توجد صور",
    productList: "قائمة المنتجات",
    dialog1: "الرجاء تحديد المنتج",
    dialog2: "هذه البضائع معبأة في صناديق",
    dialog3: "الرجاء إدخال عدد الصناديق",
    dialog4: "الكمية المتبقية من العبوة غير كافية",
    dialog5: "عدد الصناديق المعبأة أكبر من الكمية المتبقية",
    dialog6: "تم الانتهاء من إضافة المنتج",
    dialog7: "ولا يمكن اختيار نفس الصندوق",
    dialog8: "تحرير اسم المنتج",
    dialog9: "تحرير صور المنتج",
    warehouseInfo: "معلومات المستودع",
    warehouseWorkOrderNumber: "رقم طلب العمل في المستودع",
    warehouseStorageName: "اسم مستودع التخزين",
    entrustEnterpriseOB: "مؤسسة مؤتمنة من الخارج",
    enterprise: "شركة",
    warehouseData: "بيانات الدخول",
    meter: "متر مكعب",
    kilo: "كيلوغرام",
    existingData: "البيانات الموجودة",
    warehouseDetail: "تفاصيل الجرد",
    warehouseType: "نوع المستودع",
    option1: "نقل",
    option2: "خارج المستودع",
    onePiece: "شحنة واحدة",
    selectCargo: "اختر السلع الصادرة",
    goodsExistDetail: "تفاصيل السلع الموجودة",
    selectAll: "تحديد الكل",
    parentBoxName: "اسم الصندوق الرئيسي",
    dayOfStorage: "أيام التخزين",
    updateName: "تحديث اسم المنتج",
    updateImage: "تحديث الصورة ",
    total: "المجموع",
    productTotal: "إجمالي المنتجات",
    outboundTotal: "إجمالي الصادرات",
    boxTotal: "إجمالي الصناديق",
    pickupPerson: "معلومات سائق الاستلام",
    others: "آخرون",
    printBtn: "طباعة إيصال المستودع",
    printAgainBtn: "طباعة إيصال المستودع مرة أخرى",
    inputNumberSearch: "إبحث عن رقم عمل المستودع",
    days: "الأيام",
    costTitle: "تفاصيل التكلفة",
    sellTitle: "بيع التفاصيل",
    financialAccountNo: "رقم فاتورة التكلفة",
    customerName: "اسم العميل",
    billReferNo: "رقم مرجع فاتورة المورد",
    totalPayable: "إجمالي المبلغ المدفوع",
    viewCost: "عرض التكلفة",
    deleteCost: "حذف التكلفة",
    subTotal: "المجموع الفرعي",
    rate: "سعر",
    totalAmount: "الإجمالي",
    invoiceNo: "فاتورة الخصم",
    totalReceive: "إجمالي المبلغ المستحق",
    viewSell: "عرض البيع",
    deleteSell: "احذف البيع",
    receTotalAmount: "المبلغ الإجمالي",
    profitTotalAmount: "المبلغ الإجمالي",
    unloadText: "الرجاء إدخال رقم العمل في المستودع للبحث",
    notice: "إشعار",
    deleteCheck1: "هل أنت متأكد من حذف هذه التكلفة؟",
    deleteCheck2: "هل أنت متأكد من حذف هذا البيع؟",
    warehousingInfo: "المعلومات الواردة",
    productModel: "نموذج المنتج",
    productBrand: "العلامة التجارية",
    numberBoxes: "عدد الصناديق",
    totalPackingQuantity: "الكمية الإجمالية للتعبئة",
    totalGoodValue: "القيمة الإجمالية للبضائع",
    entrustingParty: "الطرف المفوض",
    stockQueryType: "نوع استفسار المخزون",
    stockQueryType1: "جميع البيانات",
    stockQueryType2: "عرض البيانات ذات المخزون فقط",
    queryTotal1: "العدد الإجمالي لأصناف البضائع",
    queryTotal2: "العدد الإجمالي لصناديق البضائع",
    queryTotal3: "القيمة الإجمالية للبضائع",
    statementTotal1: "العدد الإجمالي لصناديق الورود",
    statementTotal2: "الكمية الإجمالية للورود",
    statementTotal3: "القيمة الإجمالية للورود",
    statementTotal4: "العدد الإجمالي لصناديق الخروج",
    statementTotal5: "الكمية الإجمالية للخروج",
    statementTotal6: "القيمة الإجمالية للخروج",
    sort: "ترتيب",
    emailPush: "دفع البريد الإلكتروني",
    emailPushTest: "اختبار الدفع",
    emailSetting: "إعدادات البريد الإلكتروني",
    emailLabel: "بريد الدفع",
    emailError: "يرجى إعداد إعدادات البريد أولاً",
    sendSetting: "دورة الإرسال",
    sendDate: "تاريخ الإرسال",
    sendTime: "وقت الإرسال",
    configState: "حالة التكوين",
    daily: "يومياً",
    fixedDate: "تاريخ محدد",
    weekly: "أسبوعياً",
    monthly: "شهرياً",
    week0: "الأحد",
    week1: "الاثنين",
    week2: "الثلاثاء",
    week3: "الأربعاء",
    week4: "الخميس",
    week5: "الجمعة",
    week6: "السبت",
    emailLanguage: "لغة عرض البريد",
    emailLanguage1: "الصينية",
    emailLanguage2: "الإنجليزية",
  },
  marketRisk: {
    advertTitle: "عنوان الإعلان",
    advertTypeStr: "وصف أنواع الإعلانات",
    advertType: "أنواع الإعلانات",
    advertContent: "محتويات الإعلانات (محلي)",
    advertContentEn: "محتويات الإعلانات (إنجليزي)",
    showType: "نوع العرض",
    moduleType: "نوع الوحدة",
    moduleStr: "وحدة",
    lineUrl: "رابط الرابط الخارجي",
    isShow: "هل يظهر",
    newAdvert: "إعلان جديد",
    all: "الكل",
    graphic: "الإعلانات الرسومية",
    externalLinks: "روابط خارجية",
    notDisplay: "لا يظهر",
    display: "يظهر",
    pcStation: "جهاز الكمبيوتر",
    wxStation: "برنامج ميني",
    linkParam: "معلمات الرابط",
    sort: "ترتيب",
    imgUrl: "معاينة",
    customerNumber: "رقم العميل",
    customerName: "اسم العميل",
    country: "البلد",
    city: "المدينة",
    lPerson: "الشخص الاعتباري",
    sales: "المبيعات",
    phone: "رقم الهاتف",
    setBlock: "ضبط التقييد",
    closeBlock: "إغلاق الحصر",
    newRestrict: "إنشاء دليل",
    entrustEnterprise: "مؤسسة التخزين الموثوق بها",
    companyNameEn: "اسم الشركة باللغة الإنجليزية",
    companyNameSn: "اسم الشركة باختصار",
    legalPerson: "الممثل القانوني",
    legalPersonPhone: "هاتف الشخص القانوني",
    businessNo: "رقم الرخصة التجارية",
    salesName: "اسم البائع",
    salesPhone: "رقم هاتف البائع",
    addPeople: "إضافة بواسطة",
    serviceEmail: "بريد خدمة العملاء",
    contactPhone: "رقم الاتصال",
    wechat: "معرف WeChat",
    createPush: "إنشاء دفع بريد إلكتروني",
    fileQrcode: "رمز الاستجابة السريعة للملف",
    accountQrcode: "رمز الاستجابة السريعة للحسابات الرسمية",
    isEnabled: "مفعل",
  },
  salesManagement: {
    qrNumber: "رقم مرجع العرض",
    qNumber: "رقم الاقتباس",
    quoteDate: "تاريخ الاقتباس",
    quotePeople: "مقدم الاقتباس",
    companyName: "اسم الشركة",
    businessType: "أنواع الأعمال",
    delivery: "المغادرة",
    destination: "الوصول",
    supplierName: "اسم المورد",
    nickName: "رقم هاتف مُصدر الطلب",
    sales: "المبيعات",
    createTime: "وقت الإنشاء",
    state: "الحالة",
    option1: "مقتبس",
    option2: "غير مقتبس",
    addQuote: "إضافة اقتباس",
    tab1: "قائمة غير الاقتباسات",
    tab2: "قائمة الاقتباسات",
    title1: "تفاصيل استعلام العميل",
    title2: "تفاصيل السلع",
    title3: "تفاصيل عرض الأسعار",
    title4: "إضافة اقتباس",
    enterprise: "شركة",
    initiationPhone: "رقم جهة اتصال البادئ",
    initiationTime: "اخلق الوقت",
    goodsName: "اسم البضائع",
    tradeTerms: "شروط التجارة",
    pNumber: "عدد الطرود",
    volume: "الحجم",
    weight: "الوزن",
    piecesUnit: "وحدة تعبئة",
    volumeUnit: "وحدة الحجم",
    weightUnit: "وحدة الوزن",
    brand: "ماركة",
    liquid: "سائل",
    powder: "مسحوق",
    magnetic: "مغناطيسي",
    export1: "وسيط تصدير",
    export2: "استرداد ضريبة التصدير",
    export3: "استيراد",
    commission: "العمولة للإعلان",
    tdService: "خدمة التوصيل",
    takeDeliveryCity: "مدينة تسليم الدولة",
    takeDeliveryPerson: "اسم جهة التوصيل",
    takeDeliveryContactPhone: "رقم هاتف الاتصال للتسليم",
    takeDeliveryAddress: "عنوان التسليم",
    tdLocation: "مكان التسليم",
    addQuotation: "إضافة اقتباس",
    qValidity: "صلاحية الاقتباس",
    qDate: "تاريخ الاقتباس",
    customerNumber: "رقم العميل",
    deliveryPort: "ميناء المغادرة",
    destinationPort: "ميناء الوصول",
    exportType: "نوع التصدير",
    pricing: "التسعير",
    unit: "الوحدة",
    total: "المجموع",
    carrier: "ناقلة",
    transitTime: "زمن العبور",
    remark: "ملاحظة",
    polTitle: "إتهامات محلية في الشرطة",
    freightTitle: "تكاليف النقل",
    podTitle: "تهمة محلية في POD",
    serviceTitle: "رسوم الخدمات الإضافية",
    inputOrderNumber: "إبحث عن رقم طلب المركز",
    orderNumber: "رقم طلب التفويض",
    erNumber: "الرقم المرجعي الموثوق",
    orderPcState: "حالة الطلب",
    createDate: "وقت الإنشاء",
    entrustDetail: "تفاصيل التفويض",
    customerInfo: "معلومات العميل",
    addSop: "إضافة SOP",
    viewSop: "عرض SOP",
    orderState: "حالة الطلب",
    state1: "SOP غير مبني",
    state2: "غير مشغل",
    state3: "غير مشحون",
    state4: "غير مفوتر",
    state5: "غير محصل",
    state6: "مكتمل",
    createButton: "إنشاء أمر ثقة",
    title5: "رقم أمر نقل البضائع",
    title6: "المعلومات اللوجستية",
    sales: "المبيعات",
    entrustDay: "يوم الائتمان",
    shipper: "المرسل",
    consignee: "المستلم",
    notify: "إشعار",
    paymentTerms: "شروط الدفع",
    goodsData: "بيانات السلع",
    sopNumber: "رقم SOP",
    costTitle: "تفاصيل التكلفة",
    sellTitle: "تفاصيل البيع",
    notes: "تفاصيل عملية التسليم",
    entrustEnterprise: "مؤسسة التخزين الموثوق بها",
    later: "أدخل لاحقًا",
    contactPhone: "رقم الاتصال",
    address: "العنوان",
    email: "البريد الإلكتروني",
    same: "كالإخطار والمرسل إليه",
    deliveryCity: "مدينة التسليم",
    destinationCity: "مدينة الوجهة",
    entrustType: "نوع أمر الوصاية",
    costPay: "دفع التكلفة",
    rule: "قواعد العمل والعقود",
    warehouseWorkNumber: "رقم عمل المستودع",
    wbNumber: "رقم بوليصة الشحن",
    mainWbNumber: "رقم بوليصة الشحن الرئيسية",
    sideWbNumber: "رقم بوليصة الشحن الفرعية",
    customerId: "رقم العميل",
    atd: "ATD",
    invoiceNo: "رقم الفاتورة",
    createDate: "تاريخ الفاتورة",
    billTotal: "إجمالي الفاتورة",
    recommend: "المحيل",
    nuType1: "استلام",
    nuType2: "دفع",
    nuType3: "رصيد",
    accoutingTab1: "قائمة المدفوعات المستحقة",
    accoutingTab2: "قائمة المدفوعات المستلمة",
    accoutingTab3: "قائمة الأرباح",
    kefu: "خدمة العملاء",
    marketing: "التسويق",
    sales: "المبيعات",
    operation: "العملية",
    tradeTitle: "اللوجستيات التجارية",
    amountTitle: "قيمة التداول",
    receivedAmount: "المبلغ المستحق",
    receivedTotal: "إجمالي المبلغ المستلم",
    payAmount: "مبلغ الدفع",
    paidTotal: "إجمالي المبلغ المدفوع",
    subProfit: "الربح الفرعي",
    balance: "الرصيد المستحق",
    totalBalance: "إجمالي الرصيد المستحق",
    rate: "سعر الصرف",
    nuclearTitle: "الملكية النووية",
    nuclearAccountNo: "سجل حساب المعالجة",
    creditDate: "تاريخ الاعتماد",
    shortName: "اسم مختصر",
    nuclearType: "نوع حساب النواة",
    bank: "البنك المعني",
    receivableAmount: "المبلغ المستلم",
    payerName: "اسم الدافع",
    outStandingDays: "عدد الأيام المستحقة",
    creditBalance: "رصيد المبلغ الائتماني",
    taxInvoice: "سجل الفاتورة الضريبية",
    invoiceNumber: "رقم طلب الفاتورة",
    invoiceFile: "ملف الفاتورة الضريبية",
    details: "التفاصيل",
    billDetail: "تفاصيل رقم الفاتورة",
    transportType: "نوع النقل",
    chargeableWeight: "الوزن القابل للشحن",
    warehouseState1: "عدم التخزين",
    warehouseState2: "التخزين",
    warehouseState3: "مكتمل",
    createEntrustOrder: "إنشاء أمر التفويض",
    qState: "حالة الاقتباس",
    quoteTime: "وقت الاقتباس",
    createFreightOrder: "إنشاء طلب شحن",
    goodsNameEn: "اسم المنتج بالإنجليزية",
    billInformation: "معلومات بوليصة الشحن",
    shipperAddress: "عنوان الشاحن",
    shipperPhone: "هاتف الشاحن",
    shipperEmail: "بريد الشاحن الإلكتروني",
    consigneeAddress: "عنوان المستلم",
    consigneePhone: "هاتف المستلم",
    consigneeEmail: "بريد المستلم الإلكتروني",
    notifyAddress: "عنوان جهة الإخطار",
    notifyPhone: "هاتف جهة الإخطار",
    notifyEmail: "بريد جهة الإخطار الإلكتروني",
    supplier: "المورد",
    warehouseNumber: "رقم دخول المستودع",
    supplierList: "قائمة الموردين",
    invoice: "الفاتورة",
    packingList: "قائمة التعبئة",
    goodState: "حالة البضائع",
    emailShare: "مشاركة بالبريد",
    clickShare: "انقر للمشاركة",
    sendInvite: "إرسال دعوة",
    placeholderEmail: "أدخل عدة بريدات مفصولة بـ','",
    workInquiryNumber: "رقم البوليصة",
    bookingNumber: "رقم البوليصة الرئيسية",
    financialCounting: "العد المالي",
    subTotal: "الإجمالي الجزئي",
    unreceiveTotal: "عدم تلقي المبلغ الكلي",
    orderCustomer: "عميل الطلب",
  },
  supplier: {
    addTitle: "إضافة اقتباسات لخدمات الوكالات الخارجية",
    editTitle: "تعديل اقتباس خدمة الوكالات الخارجية",
    quotationCollection: "قائمة اقتباسات",
    minimumUnit: "وحدة الحد الأدنى للرسوم",
    minimum: "الحد الأدنى للرسوم",
    denistyRatio: "نسبة الكثافة",
    sectionCharge: "نطاق الرسوم",
    awWay: "مسار الوصول",
    collection: "مشروع التحصيل",
    createQuote: "إنشاء عرض أسعار",
    shipperCompany: "شركة الشحن",
    dealCount: "عدد المعاملات في آخر 12 شهرًا",
    costRecord: "رقم سجل التكلفة",
    companySn: "اسم الشركة",
    code: "ميناء العرض",
    bcType: "نوع العمل",
    unitPrice: "سعر الوحدة",
    unitPriceCharge: "وحدة رسوم الوحدة",
    address: "العنوان",
    section: "قسم",
    contact: "الاتصال",
    contactPhone: "اتصل بالهاتف",
    notes: "ملاحظات",
    email: "البريد الإلكتروني",
    area: "المنطقة",
    country: "الدولة",
    city: "المدينة",
    companyName: "اسم نشاط العميل",
    contactName: "اسم جهة الاتصال",
    phoneNumber: "رقم الهاتف",
    wechat: "معرف ويشات",
    referrer: "المُحيل",
    lastDate: "التحديث الاخير",
    cooperate: "عدد التعاون",
    serviceArea: "مساحة الخدمة",
    serviceCate: "فئة الخدمة",
    serviceCountry: "بلد الخدمة",
    operatingProducts: "المنتج التشغيلي",
    businessClass: "تصنيف الخدمة",
    serviceContent: "محتوى الخدمة",
    serviceDetail: "تفاصيل محتوى الخدمة ",
    regulatory: "الفئة التنظيمية",
    warehouseCate: "فئة المستودع",
    danger: "تسجيل تخزين البضائع الخطرة ",
    vehicleNum: "عدد المركبات",
    vehicleCate: "فئة المركبة",
    vehicleType: "نوع المركبة",
    carrier: "الناقل",
    mainBusiness: "الأعمال الرئيسية",
    exportCate: "فئة الاستيراد والتصدير",
    wbType1: "الشحن الجوي/من الجو إلى الباب ",
    wbType2: "الشحن البحري/من البحر إلى الباب ",
    wbType3: "يعبر",
    wbType4: "النقل بالسكك الحديدية ",
    export1: "صادر",
    export2: "وارد",
    business1: "الشحن الجوي أولاً",
    business2: "خدمة التأجير ",
    business3: "حجز الشحن البحري",
    business4: "حاوية خاصة ",
    business5: "وكيل الخدمات",
    area1: "في المدينة ",
    area2: "في المحافظة ",
    area3: "في البلد ",
    area4: "ماكاو",
    area5: "هونغ كونغ",
    car1: "مركبة عادية ",
    car2: "مركبة الإشراف ",
    car3: "مركبة عبور ",
    car4: "سيارة مبردة",
    weight1: "3 طن ",
    weight2: "5 طن",
    weight3: "8 طن",
    weight4: "10 طن",
    weight5: "12 طن",
    weight6: "18 طن",
    weight7: "مقطورة",
    weight8: "شاحنة نقل ",
    weight9: "سيارة مسطحة ",
    serveWarehouse1: "التخزين المحلي ",
    serveWarehouse2: "مخازن هونغ كونغ وماكاو وتايوان ",
    serveWarehouse3: "التخزين الخارجي ",
    superviseWarehouse1: "مستودع عادي ",
    superviseWarehouse2: "مستودع مرهون",
    superviseWarehouse3: "مستودع خاضع للإشراف ",
    superviseWarehouse4: "مستودع خارجي بواسطة امازون",
    typeWarehouse1: "شقة خارجية ",
    typeWarehouse2: "مستودع داخلي ",
    typeWarehouse3: "ساحة الحاويات ",
    typeWarehouse4: "أرضي ",
    typeWarehouse5: "تخزين داخلي عادي ",
    typeWarehouse6: "مستودع الفرز للتجارة الإلكترونية ",
    typeWarehouse7: "تخزين بدرجة حرارة ثابتة ",
    typeWarehouse8: "التخزين المبرد ",
    typeWarehouse9: "مستودع البضائع الخطرة ",
    service1: "البيان الجمركي ",
    service2: "الوكالة التجارية ",
    service3: "التعبئة والتغليف والمواد ",
    service4: "تأمين الشحن ",
    service5: "خدمة الموانئ ",
    service6: "مسح تفتيشي ",
    service7: "قانون الشحن ",
    tab1: "خدمة نقل المورد ",
    tab2: "خدمات النقل الآلي للموردين ",
    tab3: "خدمات تخزين الموردين ",
    tab4: "خدمات دعم الموردين ذات القيمة المضافة ",
  },
  enterpriseLogistics: {
    searchText1: "اسم المنتج / العلامة التجارية / الطراز",
    searchText2: "الاسم / رقم الهاتف",
    assetClassName: "اسم فئة الأصل",
    accountName: "إسم الحساب",
    accountNumber: "رقم الحساب",
    setMealConfig: "ملف تشكيل النظام",
    loginPassword: "كلمة مرور تسجيل الدخول",
    accountLocation: "موقع الحساب",
    assetState: "حالة الأصل",
    aState1: "في المتجر",
    aState2: " إقراض ",
    aState3: "إرجاع",
    goodsName: "إسم المنتج",
    goodsModel: "طراز المنتج",
    goodsBrand: "العلامة التجارية للمنتج",
    goodsConfig: "تكوين المنتج",
    goodsSize: "حجم المنتج",
    goodsArea: "مساحة المنتج",
    goodsAddress: "عنوان المنتج",
    purchaseDate: "تاريخ الشراء",
    openingDate: "تاريخ فتح الحساب",
    handoverDate: "تاريخ التسليم",
    purchaseAmount: "قيمة الشراء",
    handoverRecord: "سجل تسليم الخدمة",
    assetType: "نوع الأصل",
    addClass: "إنشاء الفئة",
    className: "اسم الفئة",
    fixedAssets: "الأصول الثابتة",
    digitalAssets: "الأصول الرقمية",
    createAssets: "إنشاء الأصول",
    editAssets: "تحرير الأصول",
    addClass: "إنشاء الفئة",
    fileList: "قائمة الملفات",
    class: "الفئة",
    photo: "صورة",
    incharge: "المسؤول",
    customerNumber: "رقم العميل",
    surname: "الاسم",
    position: "المنصب",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    phoneNumber: "رقم الهاتف",
    nativePlace: "المكان الأصلي",
    education: "التعليم",
    entryState: "حالة الدخول",
    employment: "موظف",
    dimission: "إزالة",
    entryDate: "تاريخ التحميل",
    resignationDate: "تاريخ المغادرة",
    employeeResign: "استقالة الموظف",
    listOrderBy: "فرز",
    orderBy1: "فرز المعلومات حسب وقت الدخول",
    orderBy2: "فرز حسب تاريخ الدخول",
    orderBy3: "فرز حسب تاريخ المغادرة",
  },
  currencySettings: {
    searchText: "العملة أو العملات",
    addButton: "إنشاء عملة",
    currency: "العملة",
    currencySn: "الاسم المختصر للعملة",
    currencySymbol: "رمز العملة",
    useState: "استخدام الولاية",
    settlement: "عملة التسوية",
    setCurrency: "تعيين عملة التسوية",
  },
  invoiceTitle: {
    titleType: "نوع العنوان",
    unit: "وحدة",
    taxNumber: "رقم الضريبة للشركة",
    address: "عنوان الشركة",
    phone: "رقم هاتف الشركة",
    bankName: "اسم البنك",
    bankAccount: "رقم حساب البنك",
    alert:
      "لا يُسمح بتعديل عنوان الشركة ورقم الضريبة بعد الإضافة. إذا تم إجراء التعديل، يُرجى تقديم طلب أو الاتصال بخدمة العملاء مباشرةً للتعديل",
  },
  consumptionRecord: {
    allOrderNumber: "جميع أرقام الطلبات",
    cOrderNumber: "رقم الطلب",
    orderType: "نوع الطلب",
    orderState: "حالة الطلب",
    paymentState: "نوع الدفع",
    totalAmount: "إجمالي مبلغ الطلب",
    payAmount: "مبلغ الدفع",
    orderTime: "وقت الطلب",
    actualDate: "وقت دفع الطلب",
    methods: "طريقة الدفع",
    typeOption1: "بدء الاستخدام",
    typeOption2: "تمديد",
    typeOption3: "تجديد",
    stateOption1: "غير مدفوع",
    stateOption2: "مدفوع",
    stateOption3: "منتهي",
    paymentOption1: "وي تشات",
    paymentOption2: "علي باي",
    paymentOption3: "حساب عام",
    paymentTitle: "الرجاء تحويل المال إلى الحساب التالي",
    bankName: "اسم البنك",
    bankAccount: "رقم حساب البنك",
    hotline: "خط ساخن",
    gotoPay: "الأجور"
  },
  financialAuditProcessSettings: {
    tab1: "تدقيق تكاليف الأعمال",
    tab2: "تدقيق نفقات التشغيل",
    auditor: "مراجع حسابات",
    level: "المستوى",
    job: "المسمى الوظيفي",
    charge: "الشخص المسؤول",
    cashier: "أمين الصندوق",
  },
  getWayBillOperationLog: {
    searchText1: "رقم العملية",
    searchText2: "رقم التسجيل التسلسلي/الاستعلام عن الدفع",
    tab1: "طريقة سجلات أرقام الفواتير",
    tab2: "سجلات فاتورة الإدخال",
    log: "سجلات العمليات",
    content: "محتوى التشغيل",
    inquiryNumber: "رقم استفسار الدفع",
    srNumber: "رقم التسجيل التسلسلي",
    date: "تاريخ التشغيل",
    username: "المشغل",
  },
  expenseCategorySettings: {
    project: "مشروع",
    name: "اسم الفئة",
    category: "فئة النفقات الفرعية",
    parent: "الفئة الرئيسية ",
    addTitle: "إنشاء فئة النفقات",
    editTitle: "تعديل فئة المصروفات",
    addButton: "إنشاء فئة النفقات",
  },
  userList: {
    searchText: "اسم المستخدم / رقم الهاتف",
    avatar: "أفاتار",
    username: "اسم المستخدم",
    createTime: "وقت التسجيل",
    contactNumber: "رقم الاتصال",
    phone: "رقم الهاتف",
    email: "عنوان البريد الإلكتروني",
    parentUserName: "مدير القسم",
    password: "كلمة المرور",
    userState: "حالة المستخدم",
    roleName: "دور النظام ",
    parentName: "الرئيس المباشر",
    freeze: "تجميد",
    thaw: "إلغاء التجميد",
    status: "الحالة",
    option1: "عادي",
    option2: "غير مجمد",
    addUser: "إضافة مستخدم",
    verifyCode: "رمز التحقق",
    get: "إرسال",
    assignRole: "تعيين الأدوار",
    role: "اسم الدور",
    deleteText: "هل أنت متأكد من حذف هذا المستخدم؟",
    selectRole: "الرجاء تحديد دور",
    selectUser: "الرجاء تحديد مستخدم",
  },
  roleList: {
    role: "اسم الدور",
    editRole: "تحرير الدور",
    addRole: "إنشاء دور",
    isSuper: "تعيين دور المشرف",
    dialogText: "هل أنت متأكد من حذف هذا الدور؟",
    setRight: "تعيين الحق",
    searchText: "بحث عن اسم الدور",
    roleClass: "تصنيف الشخصيات",
    manager: "المدير",
    distributor: "موزع"
  },
  store: {
    companyName: "اسم الشركة",
    companyAccount: "حساب الشركة",
    remind: "الحساب المتبقي",
    vpDate: "تاريخ انتهاء صلاحية الحزمة",
    unpaidText: "لديك طلب معلق للدفع",
    onPay: "الذهاب للدفع",
    back: "عودة",
    isBuy: "تم الشراء",
    accountNumber(val) {
      return "رقم الحساب (" + val + "¥/حساب)";
    },
    accountLanguage(val) {
      return "نظام متعدد اللغات (" + val + "¥)";
    },
    accountWxMini(val) {
      return "برنامج ويشات المصغر (" + val + "¥)";
    },
    validityDate: "مدة الصلاحية",
    cutoff: "تاريخ انتهاء الصلاحية بعد",
    menusLabel: "اختيار الحزمة (خيارات متعددة)",
    coupon: "كوبون",
    payCurrency: "عملة الدفع",
    methods: "طريقة الدفع",
    totalAmount: "المبلغ الإجمالي",
    discountAmount: "مبلغ الخصم",
    payAmount: "مبلغ الدفع",
    agreementText: "لقد قرأت وأوافق على اتفاقية خدمة Vtrack",
    orderButton: "اطلب الآن",
    stepOption1: "بدء الاستخدام",
    stepOption2: "تمديد",
    stepOption3: "تجديد",
    ruleIsAgree: "يرجى التحقق من اتفاقية الخدمة",
    paymentOption1: "وي تشات",
    paymentOption2: "علي باي",
    paymentOption3: "الدفع غير المباشر",
    expire: "انتهي",
    year: "سنة",
    guideText: "يرجى النقر على العمل الذي تريد تنفيذه",
  },
  clientFund: {
    serialRegistrationNumber: "رقم التسجيل التسلسلي",
    creditRefNo: "رقم المرجع الائتماني",
    exchangeNo: "رقم الصرف",
    fundClass: "فئة التمويل",
    paymentType1: "رسوم العمل",
    paymentType2: "رسوم التشغيل",
    accountName: "اسم الحساب",
    remitterName: "اسم المُحيل",
    remittanceLocation: "موقع التحويلات المالية",
    remittanceAmount: "مبلغ التحويل",
    remittanceCurrency: "عملة التحويل",
    bankCharges: "الرسوم المصرفية",
    bankChargesCurrency: "الرسوم المصرفية على العملة",
    customerNumber: "رقم العميل",
    customerName: "اسم العميل",
    companyName: "اسم الشركة",
    receivedAmount: "استلام المبلغ",
    receivedCurrency: "استلام العملة",
    transferDate: "تاريخ التحويل",
    bankAccount: "الحساب البنكي",
    minAmount: "الحد الأدنى",
    maxAmount: "الحد الأقصى",
    inquiryNumber: "رقم الاستفسار عن الدفع",
    paymentTradeNumber: "رقم معاملة الدفع",
    fillInDate: "تاريخ التعبئة",
    receiveDate: "تاريخ الاستلام",
    entryType: "نوع الدخول",
    type1: "تمويل",
    type2: "الأعمال التجارية",
    entryState: "حالة الدخول",
    entryState1: "غير مستقر",
    entryState2: "استقر",
    entryState3: "محذوف",
    remark: "ملاحظة",
    agent: "وكيل",
    entryFile: "ملف الدخول",
    dic1: "مبلغ غير مستلم",
    dic2: "المبلغ الإجمالي غير المستلم",
    dic3: "مبلغ الرصيد",
    dic4: "إجمالي مبلغ الرصيد",
    clientFundUse: "صندوق العملاء يستخدم التفاصيل",
    clientFundData: "إجمالي المبلغ المستحق",
    sort: "الطلب حسب",
    fundType: "نوع التمويل",
    fdType1: "الدخل",
    fdType2: "النفقات",
    fdType3: "إيرادات الصرف",
    fdType4: "نفقات الصرف",
    fdType5: "ألغي",
    operateDate: "تاريخ التشغيل",
    bookCurrency: "العملة",
    bookAmount: "مبلغ محفوظ",
    originBalance: "الرصيد الأصلي للحساب",
    bookBalance: "رصيد حساب مسك الدفاتر",
    username: "تشغيل المستخدم",
    writeOff1: "شطب العملة",
    writeOff2: "خصم المبلغ",
    writeOff3: "حذف الملاحظة",
    useButton1: "تفاصيل تحويل أموال العملاء",
    useButton2: "تفاصيل نقاط",
    useButton3: "سجل صرف أموال العملاء",
    exchangeCurrency: " صرف العملة ",
    exchangeAmount: " قيمة الصرف ",
    exchangeBeforeBalance: "الرصيد قبل الصرف",
    exchangeAfterBalance: "الرصيد بعد الصرف",
    convertBeforeBalance: "الرصيد قبل التويل",
    convertAfterBalance: "الرصيد بعد التحويل",
    rate: "سعر الصرف",
    fromCurrecny: "العملة التي سيتم صرفها",
    toCurrency: "العملة التي تحتاج إلى تغييرها",
    toAmount: "المبلغ بعد",
    mainWbNumber: "سند الشحن الرئيسي",
    sideWbNumber: "سند الشحن الداخلي",
    invoiceNo: "فاتورة الخصم",
    warehouseWorkNumber: " رقم وظيفة المستودع",
    createDate: "وقت الإنشاء",
    beforeBlance: "الرصيد المتاح",
    afterBlance: "بعد الصرف",
    frozenBalance: "الرصيد المجمد",
    amountStatistics: "إحصائيات المبلغ",
    dateStatistics: "إحصائيات التاريخ",
    createTime: "وقت الإنشاء",
    customer: "العميل",
    fileList: " قائمة الملفات ",
    file: "ملف",
    businessTitle1: "عرض مدخلات أعمال صندوق العميل",
    businessTitle2: "تحرير إدخال أعمال صندوق العميل",
    businessTitle3: "إنشاء إدخال أعمال صندوق العميل",
    businessAddButton: "إنشاء إدخال أعمال صندوق العميل",
    fundsTransferCustomerNumber: "رقم العميل المحول له الاموال",
    fundsTransferCustomerName: "اسم العميل المحول إليه الأموال",
    transferUserName: "اسم التحويل للمستخدم",
    financeTitle1: "عرض مدخل تمويل العميل",
    financeTitle2: "تحرير مدخل تمويل العملاء",
    financeTitle3: "إضافة مدخل تمويل صندوق العميل",
    financeAddButton: "إنشاء مدخل تمويل لصندوق العملاء",
    transfer1: "تحويل أموال العميل",
    transfer2: "تأكيد",
    transfer3: "إلغاء",
    transferNotice: "يرجى تحديد نفس المحول للتحويل",
    customerNotice: "تؤكد المالية إدخال حساب العميل أدناه، أو انقر لتعديل حساب العميل",
    clickNotice: "حدد فاتورة العمل",
    selectBill1: "يرجى تحديد فاتورة إدخال الأعمال",
    selectBill2: "يرجى تحديد فاتورة إدخال التمويل",
    exchange: "الصرف",
    writeOff: "ألغي",
    all: "الكل",
    currencyError: "لا يمكن اختيار نفس العملة",
    excess: "فائض الرصيد المتاح",
    applicant: "مقدم الطلب",
  },
  buildWayBillNo: {
    kefu: "خدمة العملاء",
    marketing: "التسويق",
    sales: "المبيعات",
    operation: "العملية",
    shippingDetail: "تفاصيل الشحن",
    shipperCompany: "شركة الشاحن",
    address: "العنوان",
    country: "الدولة",
    destination: "تفاصيل الوجهة",
    consigneeCompany: "شركة المستلم",
    phone: "رقم الهاتف",
    postalCode: "الرمز البريدي",
    trackNumberDetails: "تفاصيل رقم التتبع",
    productName: "اسم المنتج",
    customsCode: "رمز الجمارك",
    weight: "الوزن",
    numberBoxes: "عدد الصناديق",
    boxUnit: "وحدة الصندوق",
    volume: "الحجم",
    value: "سعر السلعة",
    currency: "العملة",
    others: "آخرون",
    tradingPlatform: "منصة التجارة",
    remark: "ملاحظة",
    totalData: "إجمالي البيانات",
    totalWeight: "إجمالي الوزن",
    totalCases: "إجمالي عدد الحالات",
    contactError: "الشركة ليس لديها شخص للاتصال",
    selectUser: "الرجاء تحديد مستخدم",
    selectDate: "الرجاء تحديد تاريخ",
    wbNumber: "رقم بوليصة الشحن",
    wbNumberData: "تحميل البيانات الرئيسية أو البيت بي/ل",
    totalCargoQuantity: "إجمالي كمية البضائع",
    cargoQuantity: "كمية العناصر",
    searchCustomsCode: "البحث عن رمز الجمارك",
    searchCommodityCode: "ابحث عن رمز السلعة",
    customsCommodityCode: "رمز البضاعة الجمركية المخصص",
  },
  antiMoneyLaundering: {
    title1: "التحقيق في قائمة مكافحة غسل الأموال",
    title2: "تفاصيل مكافحة غسل الأموال",
    search: "بحث",
    antiSearch: "التحقيق في مكافحة غسل الأموال",
    name: "الاسم",
    address: "العنوان",
    identityNum: "رقم المعرف",
    bic: "كود BIC",
    country: "البلد/المنطقة",
    narrative: "السرد",
    swift: "رسالة سريعة",
    tshpzh: "رقم العمل",
    caseId: "رقم التحذير",
    attribute: "سمة القائمة",
    qPeople: "البحث بواسطة",
    qDate: "تاريخ البحث",
    antiOption1: "عادي",
    antiOption2: "الجزاءات",
    queryResult: "نتيجة البحث",
    antiView: "عرض تحذيري",
    dialogQueryTitle: "هذه المعلومة تم استجوابها خلال 30 يوم، هل تحتاج إلى استعلام مرة أخرى؟",
  },
  platformOrders: {
    tab1: "قائمة الطلبات",
    tab2: "قائمة البيان",
    orderCustomerinvoicecode: "رقم الطلب",
    wbNumber: "رقم فاتورة الطريق",
    paymenttypeCode: "رمز الدفع",
    paymentType: "نوع الدفع",
    boxNo: "رقم الصندوق",
    mawb: "الطلب الرئيسي رقم.",
    weight: "الوزن",
    volume: "حجم الصوت",
    totalValue: "القيمة الإجمالية",
    totalWeight: "إجمالي الوزن الصافي",
    orderPiece: "عدد القطع",
    referenceNo: "المرجع رقم.",
    packageNo: "لا حزمة.",
    orderDate: "تاريخ الطلب",
    createTime: " إنشاء الوقت ",
    expectedDeliveryDate: "تاريخ ما قبل الوصول",
    consigneeOrShipperName: "اسم المرسل/الشاحن",
    consigneeOrShipperCompanyName: "اسم شركة المرسل إليه/الشاحن",
    consigneeOrShipperPhone: "رقم هاتف المرسل/الشاحن",
    consigneeName: "اسم المرسل إليه",
    consigneeCompanyname: "اسم الشركة المرسل إليها",
    consigneeTelephone: "رقم هاتف المرسل",
    consigneeMobile: "رقم هاتف المرسل",
    consigneeAddress: "عنوان المرسل إليه",
    consigneeCountry: "البلد المرسل إليه",
    consigneeCity: "مدينة المرسل إليه",
    consigneeCountryCity: "البلد/المدينة المرسل إليها",
    consigneeState: "المقاطعة المرسل إليها",
    consigneePostcode: "الرمز البريدي",
    consigneePassportno: "رقم جواز سفر المرسل إليه",
    consigneeEmail: "البريد الإلكتروني المرسل إليه",
    consigneeTaxno: "رقم ضريبة المرسل إليه",
    shipperName: "اسم الشاحن",
    shipperCompanyname: "اسم شركة الشحن",
    shipperTelephone: "رقم هاتف الشاحن",
    shipperPhone: "رقم هاتف الشاحن",
    shipperAddress: "عنوان الشاحن",
    shipperCountry: "بلد الشاحن",
    shipperState: "مقاطعة الشحن",
    shipperCity: "مدينة الشحن",
    shipperPostcode: "الرمز البريدي لناقل الشحن",
    shipperPassportno: "رقم جواز سفر الشاحن",
    shipperEmail: "البريد الإلكتروني للشحن",
    shipperTaxnotype: "نوع رقم الضريبة",
    shipperTaxno: "رقم الضريبة على الشاحن",
    shipperTaxnocountry: "البلد رقم ضريبة الشاحن",
    orderCodamount: "كمية سمك القد",
    orderCodcurrency: "عملة سمك القد",
    chargeableWeight: "الوزن القابل للشحن",
    codOrNonCod: "هل هو سمك القد",
    itemDescEn: "وصف السلع باللغة الإنجليزية",
    itemQuantity: "كمية السلع",
    declareValue: "القيمة المعلنة",
    declareValueCurrency: "العملة المعلنة القيمة",
    label1: "معلومات الطلب",
    label2: "معلومات المرسل إليه",
    label3: "معلومات الشاحن",
    label4: "معلومات المستورد",
    label5: "طلب المنتجات",
    customerinvoicecode: "رقم تعريف العميل/رقم تعريف العميل.",
    orderReturnsign: "علامة العودة",
    tradeType: "نوع التداول",
    orderTransactionurl: "عنوان مبيعات المنتج",
    orderCargoamount: "طلب كمية السلع",
    orderInsurance: "مبلغ التأمين",
    cargoType: "نوع العبوة",
    importCode: "رمز المستورد",
    importName: "اسم المستورد",
    importCompanyname: "اسم الشركة المستوردة",
    importAddress: "عنوان المستورد",
    importTelephone: "رقم هاتف المستورد",
    importEmail: "البريد الإلكتروني للمستورد",
    importPostcode: "الرمز البريدي للمستورد",
    importCountry: "بلد المستورد",
    importState: "مقاطعة المستورد",
    importCity: "مدينة مستوردة",
    invoiceAmount: "القيمة الإجمالية المعلنة",
    invoiceCurrency: "العملة المعلنة",
    invoiceTitle: "اسم المنتج باللغة الإنجليزية",
    sku: "اسم المنتج الصيني",
    skuCode: "معلومات التوزيع",
    hsCode: "كود HS",
    invoicePcs: "عدد القطع",
    invoiceWeight: "الوزن أحادي القطعة",
    invoiceVolume: "وحدة صوت القطعة الواحدة",
    volumeHeight: "الارتفاع",
    volumeLength: "طويل",
    volumeWidth: "العرض",
    volumeWeight: "الوزن الفعلي",
    transactionUrl: "عنوان المبيعات",
    invoiceunitCode: "وحدة التقارير",
    invoiceImgurl: "عنوان الصورة",
    noImage: "لا صور",
    invoiceBrand: "العلامة التجارية",
    invoiceRule: "المواصفات",
    invoiceTaxno: "رقم التعريفة",
    originCountry: "بلد المنشأ",
    invoiceMaterial: "المادة",
    invoicePurpose: "الغرض"
  },
  vehicles: {
    vin: "رقم تعريف المركبة",
    plate: "رخصة المركبة",
    brand: "العلامة التجارية",
    model: "الموديل",
    color: "اللون",
    length: "طول المركبة (بالأمتار)",
    width: "عرض المركبة (بالمتر)",
    height: "ارتفاع المركبة (بالأمتار)",
    vehicleType: "نوع المركبة",
    vehiclePhoto: "صورة مركبة",
    dimensions: "أبعاد المركبة",
    maxLoad: "الحد الأقصى للحمولة (كجم)",
    vehicleStatus: "حالة المركبة",
    vStatus1: "قيد الاستخدام",
    vStatus2: "صيانة",
    vStatus3: "إلغاء التنشيط",
    vStatus4: "الخردة",
    addVehicle: "إنشاء مركبة",
    editVehicle: "تحرير المركبة",
    updateVehicleStatus: "تحديث حالة المركبة",
    sheetNotice: "يرجى اختيار السيارة أولا",
  },
  expressEmployee: {
    addEmployeeRole: "إنشاء معلومات موظف جديد",
    editEmployeeRole: "تحرير الموظف",
    employeeRole: "دور الموظف",
    role1: "السائق",
    role2: "المخلص",
    role3: "حارس مستودع",
    surname: "الاسم",
    male: "ذكر",
    female: "انثى",
    gender: "الجنس",
    nationality: "الجنسية",
    birthDate: "تاريخ الميلاد",
    idCardNumber: "رقم بطاقة الهوية",
    idCardAddress: "عنوان بطاقة الهوية",
    currentAddress: "العنوان الحالي",
    phoneNumber: "رقم الهاتف",
    alternatePhone: "هاتف بديل",
    email: "البريد الإلكتروني",
    emergencyContact: "مسؤول الاتصال في حالات الطوارئ",
    emergencyPhone: "رقم جهة اتصال الطوارئ",
    addUser: "إضافة مستخدم",
    createTime: "اخلق الوقت",
    accountActivate: "تنشيط الحساب",
    aStatus1: "غير نشط",
    aStatus2: "تم تنشيط",
    accountLock: "قفل الحساب",
    lStatus1: "عادي",
    lStatus2: "مقفل",
    createButton: "إنشاء موظف",
    lockButton: "أقفل",
    unlockButton: "الفتح",
    avatarPhoto: "صورة أفاتار",
  },
  cargoWarehousing: {
    returnWarehouse: "العودة إلى المخزن",
    exceptionHandling: "مناولة الاستثناءات",
    exceptionReason: "سبب الاستثناء",
    deliveryExceptionReason: "سبب استثناء التسليم",
    exceptionNotice: "تحذير إعادة تعيين",
    exceptionText(val) {
      return "يتم دعم عملية إعادة الانتداب حتى 3 مرات على الأكثر. يمكنك أيضا تشغيل " + val + " أوقات";
    },
    exceptionAddress: "عنوان الشحن",
    exceptionTrim: "ويبلغ الحد الأقصى لعدد الأشخاص الذين يعاد تعيينهم ثلاث مرات",
    transferDeliveryCount: "وقت إعادة التخصيص",
    eState1: "إعادة تعيين",
    eState2: "العودة إلى المخزن",
    tab1: "في انتظار التسليم",
    tab2: "الشحنة في المستودع",
    tab3: "قائمة الصادر",
    tab4: "البضائع المستثناة",
    label1: "معلومات الطلب",
    label2: "معلومات المرسل إليه",
    label3: "معلومات تسليم السائق",
    label4: "معلومات المخازن",
    label5: "معلومات التسليم",
    label6: "تفاصيل البضاعة",
    outboundBatch: "الدفعة الصادرة",
    warehouseEntryNumber: "رقم دخول المستودع",
    wbNumber: "رقم سند الشحن",
    mainWbNumber: "بوليصة اصلية",
    sideWbNumber: "بوليصة داخلية",
    totalNumber: "إجمالي عدد العبوات",
    totalWeight: "إجمالي الوزن الصافي",
    totalValue: "إجمالي الحجم",
    isCodorder: "طلب القدّ",
    consignee: "المرسل إليه",
    consigneePhone: "رقم هاتف المرسل",
    consigneeAddress: "عنوان المرسل إليه",
    pod: "ميناء التفريغ",
    headPhoto: "صورة السائق",
    noImage: "لا صور",
    driver: "السائق",
    driverName: "سائق توصيل",
    driverOrStorageName: "اسم السائق أو حارس المستودع",
    driverDeliveryState: "حالة تسليم السائق",
    dState1: "لم يتم التسليم",
    dState2: "التنفيذ جارٍ",
    dState3: "تسليم",
    phoneNumber: "رقم هاتف السائق",
    vehicle: "المركبة",
    vehiclePhoto: "صورة مركبة",
    licensePlate: "رقم لوحة التسليم",
    color: "اللون",
    cargoReceivedPhoto: "صورة الحمولة المستلمة",
    cargoArrivalPhoto: "صورة وصول الشحنة",
    uploadTime: "وقت التحميل",
    warehouse: "مستودع",
    warehouseCode: "رمز المستودع ",
    warehouseName: "اسم المستودع",
    warehouseAddress: "عنوان المستودع",
    storageHeadPhoto: "أفاتار عامل المستودع",
    storageName: "اسم عامل المستودع",
    storagePhoneNumber: "رقم هاتف عامل المستودع",
    warehouseKeeper: "حارس مستودع",
    cargoWarehousingTime: "وقت تخزين البضائع",
    applyOutboundTime: "وقت الإرسال",
    outboundTypeLabel: "النوع الصادر",
    outboundType1: "خارج المخزن",
    outboundType2: "النقل",
    deliverer: "المخلص",
    deliveryPersonHeadPhoto: "أفاتار",
    deliveryPersonName: "اسم المرسل",
    deliveryPersonPhoneNumber: "رقم هاتف المولد",
    deliveryTime: "وقت التسليم",
    completionTime: "وقت الإنجاز",
    goodsName: "اسم البضاعة",
    hsCode: "كود HS",
    orderPiece: "عدد القطع",
    weight: "الوزن",
    volume: "حجم الصوت",
    goodsValue: "قيمة العنصر",
    outBoundState: "حالة الخروج",
    obState1: "بانتظار الخروج",
    obState2: "التنفيذ جارٍ",
    obState3: "اكتمل",
    obState4: "في انتظار العودة",
    applyOutbound: "تقديم الطلب",
    editOutbound: "تحرير المجموعة الصادرة",
    viewTitle: "عرض مستودع البضائع السريعة",
    editTitle: "تحرير مستودع البضائع السريعة",
    submitNotice1: "وستؤدي العملية الحالية إلى إعادة رقم وثيقة الشحن غير المختارة من المستودع. هل تريد المتابعة؟",
    submitNotice2: "العملية الحالية سوف تحذف رقم بيان الشحن غير المحدد هل تريد المتابعة؟",
    mawbNumber: "عدد الصناديق الكبيرة",
    username: "المشغل",
    createTime: "وقت العملية",
    exception1: "مناولة الاستثناءات",
    exception2: "سجل الاستثناء",
    postcode: "الرمز البريدي",
    receivingName: "المستلم",
    contactPhone: "رقم الاتصال",
    country: "البلد",
    city: "المدينة",
    receivingAddress: "تفاصيل عنوان التسليم",
  },
  onlineOrder: {
    quotationNo: "رقم الاقتباس/اسم المنتج",
    shippingProductName: "اسم المنتج الشحن",
    warehouseSearch: "اسم/رمز المستودع",
    warehouseCode: "رمز المستودع",
    warehouseName: "اسم المستودع",
    warehouseAddress: "عنوان المستودع",
    warehouseStatus: "حالة المستودع",
    warehouseContact1: "جهة الاتصال 1",
    warehouseContact2: "جهة الاتصال 2",
    warehousePhone: "رقم الاتصال",
    warehouseEmail: "بريد الاتصال",
    warehouseTime: "وقت العمل",
    warehouseGoods: "بضائع المستودع",
    companyName: "اسم الشركة",
    companyIcon: "شعارات الشركة",
    contact: "الاتصال",
    state: "الحالة",
    quoUpdateTime: "تاريخ تحديث الاقتباس",
    bjNumber: "رقم الاقتباس",
    username: "مستخدم التحديث",
    countryName: "اسم البلد",
    countryFlag: "العلم الوطني",
    addPeople: "إضافة بواسطة",
    createTime: "إنشاء تاريخ",
    updateTime: "تاريخ التحديث",
    disableOption: "معطل",
    enableOption: "مفعل",
    addTitle1: "إنشاء سعر الشحن",
    editTitle1: "تعديل سعر الشحن",
    viewTitle1: "عرض سعر الشحن",
    addTitle2: "إنشاء معلومات المخزن",
    editTitle2: "تحرير معلومات المخزن",
    addTitle3: "إنشاء معلومات اقتباس",
    editTitle3: "تعديل معلومات الاقتباس",
    addTitle4: "إنشاء عرض تسعير للمورد",
    editTitle4: "تعديل عرض المورد",
    stepper1: "تفاصيل عروض الأسعار",
    stepper2: "تفاصيل سعر الشحن",
    firstTab: "إدارة الشحن Express",
    secondTab: "إدارة المستودع",
    thirdTab: "إدارة الاقتباسات Vancheen",
    fourthTab: "خدمات التخليص الجمركي عبر الحدود الخارجية",
    attribute: "الخصائص غير المقبولة للسلع",
    liquid: "سائل",
    powder: "مسحوق",
    paste: "معجون",
    charged: "مشحون",
    magnetic: "مغناطيسي",
    unlimited: "غير محدود",
    arrivalCountry: "بلد الوصول",
    firstWeightPrice: "سعر الوزن الأول",
    continuePrice: "استمرار سعر الوزن",
    firstEachWeight: "الوزن الأول لكل كيلوغرام",
    firstWeight: "الوزن الثقيل الأول",
    continueWeightPrice: "وزن مستمر لكل كيلوغرام",
    continueWeight: "وزن مستمر",
    arriveDay: "يوم الوصول",
    cargoCategory: "خدمة النقل باللغة الصينية",
    cargoCategoryEn: "خدمة النقل باللغة الإنجليزية",
    transportTime: "وقت النقل (بالأيام)",
    cargoCategorySn: "خدمة النقل",
    postNumber: "رقم المنشور",
    goodsName: "اسم البضائع",
    cargoTrackingNumber: "رقم تتبع الحمولة",
    customerNumber: "رقم العميل",
    customerName: "اسم العميل",
    storageTime: "زمن التخزين",
    numberPackages: "عدد الحزم",
    numberPackagesSn: "العبوات",
    volume: "حجم الصوت",
    weight: "الوزن",
    weightUnit: "وحدة الوزن",
    numberBoxes: "عدد الصناديق",
    numberBoxesOrder: "عدد الصناديق التي يطلبها الزبون",
    chargeableWeight: "الوزن القابل للشحن",
    noImage: "لا صور",
    outbound: "شحنة خارجية",
    tab1: "محطة اللوجستيات",
    wbNumber: "رقم فاتورة الطريق",
    departureDate: "تاريخ الشحن",
    logisticsState: "حالة اللوجستيات",
    countryCode: "رمز الدولة الوجهة",
    country: "الدولة الوجهة",
    goodState: "حالة الحمولة",
    state1: "في العبور",
    state2: "انتظر حتى يلتقط",
    state3: "انتظر التسليم",
    state4: "اكتمل",
    deliveryMethod: "طريقة التسليم",
    takeDeliveryType1: "إلتقطني من المستودع",
    takeDeliveryType2: "التقدم بطلب للتسليم",
    pickUpCode: "اختيار الرمز",
    completionTime: "تاريخ التوقيع",
    orderDate: "تاريخ الطلب",
    consigneeName: "المستلم",
    receiveCustomer: "اسم المستلم",
    receivePhone: "رقم هاتف المرسل",
    receiveAddress: "عنوان المرسل إليه",
    phoneNumber: "رقم الهاتف",
    receivingAddress: "عنوان الاستلام",
    putInStorage: "ضعي ستورج",
    dialogTitle: "طلب زبائن في المخزن",
    remark: "ملاحظة باللغة الصينية",
    remarkEn: "ملاحظة باللغة الإنجليزية",
    logoImg: "شعار",
    cargoQuantity: "كمية العناصر",
    goodsValue: "قيمة السلع",
    isUnpack: "هل سيتم فتح الحزمة؟",
    generateWaybill: "أنشئ رقم بيان الشحن",
    generateExpress: "إنشاء بيان طريق التسليم السريع",
    conversionFactor: "معامل الوزن الحجمي",
    faceSheet: "الورقة الأمامية",
    setPrice: "حدد السعر",
    viewPrice: "عرض سعر الشحن",
    discountRate: "معدل الخصم",
    addPrice: "إنشاء خصم",
    editPrice: "تعديل الخصم",
    serviceProvider: "مُقدِّم الخدمة",
    productCode: "رقم المنتج",
    dialogBillingTitle1: "يرجى إدخال معلومات الشحن",
    dialogBillingTitle2: "يرجى تأكيد تفاصيل الفاتورة",
    dialogBillingTitle3: "يرجى إكمال معلومات مزود الخدمة",
    length: "الطول",
    width: "العرض",
    height: "الارتفاع",
    weight: "الوزن",
    prevStep: "الخطوة السابقة",
    nextStep: "الخطوة التالية",
    firstWeightSn: "الوزن الأول",
    continueWeightSn: "الوزن المستمر",
    totalFreight: "البضائع الإجمالية",
    declareValue: "القيمة المعلنة",
    declareValueCurrency: "العملة المعلنة القيمة",
    deliveryZipCode: "رقم بريد المرسل",
    naqel_ShippingDateTime: "تاريخ ووقت الشحن",
    naqel_DescriptionOfGoods: "وصف البضائع",
    naqel_NumberOfPieces: "عدد القطع",
    iMile_PackageTotalVolume: "الحجم الإجمالي للطرود",
    iMile_PackageGrossWeight: "الوزن الإجمالي للطرد",
    iMile_PackageTotalCount: "العدد الإجمالي للطرود",
    iMile_PackageGoodsType: "نوع بضائع الطرد",
    itemsTitle: "تفاصيل البضائع",
    customsCurrency: "عملة التصريح الجمركي",
    hsCode: "كود HS",
    batchPrice: "إضافة خصومات بالدفعة",
    discountType: "نوع الخصم",
    discountType1: "النسبة المئوية",
    discountType2: "مبلغ ثابت",
    discountRate: "معدل الخصم",
    discountAmount: "مبلغ الخصم",
    scanTitle1: "مسح رقم المنشور",
    scanTitle2: "مسح رقم البوليصة",
    setPointRule: "قواعد النقاط",
    addRule: "إنشاء قاعدة النقاط",
    deleteRule: "قاعدة حذف النقاط",
    viewRuleHistory: "نُظَّر إلى تاريخ النقطة من وجهة نظر",
    pointsObtainConditions: "النقاط التي تُحصل عليها تحت شروط",
    pointsIncome: "دخل النقاط",
    reducedPointsIncome: "إيرادات النقاط المخفضة",
    ruleDate: "تاريخ التخلص",
    supplier: "المورد",
    area: "المنطقة",
    bcType: "نوع الأعمال",
    awWay: "مسار الوصول",
    updateTime: "التاريخ المحدث",
    companyNameKeyword: "كلمة مفتاح اسم المورد",
    serviceState: "حالة الاقتباس",
    serviceState1: "تمكّن",
    serviceState2: "إيقاف التشغيل",
    vatRate: "معدل ضريبة القيمة المضافة",
    minVatAmount: "الحد الأدنى لقيمة المبيعات الضريبية",
    minVatCurrency: "العملة الدنيا للضريبة المضافة",
    customsDutyRate: "معدل الضرائب الجمركية",
    minCustomsDutyAmount: "الحد الأدنى لرسوم الجمارك",
    minCustomsDutyCurrency: "عملة القيمة المحددة للرسوم الجمركية الدنيا",
    highValueFee: "رسوم عالية القيمة",
    highValueFeeCurrency: "عملة رسوم عالية القيمة",
    productTaxRateList: "قائمة معدلات ضريبة المنتج",
    productCategory: "فئة المنتج",
    taxFeebearingParty: "دافع الضريبة",
    shipperSn: "الشاحن",
    consigneeSn: "المرسل إليه",
    totalQty: "الكمية الإجمالية",
    unpackTitle: "تفكيك طلب العميل",
    unpackButton: "تفكيك",
    unpackQty: "كمية التفكيك",
    packageSn: "الطرود",
    taxTotal: "الضرائب",
    taxStep: "خطوات حساب الضرائب",
    isTaxFeebearingPartyInconsistent: "انتباه: في الترتيب الذي اخترته، لا تكون الأطراف المسؤولة عن دفع الضرائب متساوية. إذا استمريت في التركيبة الحالية، فإن النظام سيُفترض أن جميع الضرائب تتحملها جهة الشحنة. إذا كنت بحاجة إلى إجراء تغيير، يرجى تعديل تركيبة الطلب.",
    dialogSheetTitle: "خيارات الطباعة",
    isPrintVtrackLabel1: "ملصق توزيع مطبوع",
    isPrintVtrackLabel2: "ملصق مسار مطبوع",
    totalWeight: "الوزن الإجمالي للبضائع",
    storageOverdueDays: "أيام التخزين المتأخرة",
    shipmentCount: "عدد بوالص الشحن الرئيسية",
    billCount: "عدد بوالص الشحن الفرعية",
    conatiner20: "حاوية 20 قدماً",
    conatiner40: "حاوية 40 قدماً",
    conatiner40HQ: "حاوية 40HQ",
    cifGoodsValue: "قيمة البضائع CIF (دولار أمريكي)",
    piecesNumber: "عدد القطع",
    supplierName: "اسم المورد",
    notes: "ملاحظات التشغيل",
    chargeItems: "بنود الرسوم",
    section: "القطاع",
    billName: "فاتورة الحساب",
    chargingUnit: "وحدة التحصيل",
    minChargingPrice: "الحد الأدنى لسعر التحصيل",
    unitPrice: "السعر الوحدوي",
    isMandatoryItem: "هل هو بند إلزامي",
    mandatory1: "إلزامي",
    mandatory2: "يتم التحصيل عند التسليم",
    mandatory3: "يتم التحصيل على أساس الفاتورة الفعلية",
    costPrice: "سعر التكلفة",
    profitPrice: "سعر الربح",
    salesPrice: "سعر البيع",
    calculatePrice: "احتساب الرسوم",
    calculateDetail: "تفاصيل الاحتساب",
    chargingCurrency: "عملة التحصيل",
    oCurrency: "العملة الأصلية",
    dCurrnecy: "عملة العرض",
    isCustomsInspection: "هل يشمل التفتيش الجمركي",
    isChargeUponDelivery: "هل يشمل التحصيل عند التسليم",
    isCostReimbursement: "هل يشمل التحصيل على أساس الفاتورة الفعلية",
    totalCost: "إجمالي التكلفة",
    totalProfitPrice: "إجمالي تعديل الربح",
    totalSalesPrice: "إجمالي سعر البيع المقترح",
    recordTitle: "سجل المراسلات",
    communicationExplanation: "شرح المراسلة",
    viewRecord: "عرض السجل",
    communicationTitle: "تفاصيل سجل المراسلات",
    voucherFiles: "ملفات القيود",
    fileList: "قائمة الملفات",
    file: "ملف",
    viewFile: "عرض الملف",
    recordUserName: "المحدِّث",
    recordCreateTime: "وقت التحديث",
    divider1: "معلومات التحصيل",
    divider2: "معلومات البضائع",
    divider3: "معلومات العملات",
    divider4: "ملخص التسعير",
    divider5: "ملاحظات التسعير",
    divider6: "سجل الملاحظات",
  },
  calculator: {
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    length: "الطول (سم)",
    width: "العرض (سم)",
    height: "الارتفاع (سم)",
    weight: "الوزن (كجم)",
    search: "بحث",
    col1: "فئة السلعة",
    col2: "وحدة الوزن الأساسية",
    col3: "سعر وحدة الوزن الأساسية",
    col4: "الوزن الإضافي",
    col5: "سعر وحدة الوزن الإضافي",
    col6: "زمن النقل",
    day: "أيام",
    empty: "لا توجد بيانات",
    remark: "ملاحظة",
    orderBy1: "ارتفاع السعر",
    orderBy2: "السعر الهابط"
  },
  businessEntity: {
    companyName: "اسم الشركة",
    companyLogo: "شعار الشركة",
    officialSeal: "الختم الرسمي",
    englishName: "الاسم الإنجليزي",
    foreignLanguageName: "اسم اللغة الأجنبية",
    establishmentDate: "تاريخ التأسيس",
    legalPerson: "الشخص القانوني للشركة",
    region: "المنطقة المسجلة",
    address: "العنوان المسجل",
    registeredCapital: "رأس مال مسجل",
    remark: "ملاحظة",
    shareHolder: "قائمة المساهمين",
    fullname: "الاسم",
    equityStake: "نسبة الأسهم",
    status: "الحالة",
    option1: "طبيعي",
    option2: "إيقاف التشغيل",
    noImage: "لا صور",
    addButton: "إنشاء كيان تجاري",
    bankAccountList: "قائمة حسابات البنوك",
    bankAccount: "حساب بنكي",
    accountNickName: "اسم المستخدم للحساب",
    accountName: "اسم الحساب",
  },
  goodsInventory: {
    productName: "اسم المنتج",
    productNameEn: "الاسم الإنجليزي للمنتج",
    domesticPlaceOrigin: "المكان المحلي للبضائع المُرسلة",
    productImages: "صورة المنتج",
    productDescription: "وصف المنتج",
    productQuotation: "استعلام عن المنتج",
    customsDeclaration: "معلومات إقرار الجمارك",
    customsDeclarationName: "معلومات إقرار الجمارك",
    brand: "علامة تجارية",
    model: "نموذج",
    packageNumber: "كمية التغليف من قطعة واحدة",
    hsCode: "كود HS",
    specification: "مواصفات",
    unitName: "وحدة الاقتباس",
    customerNumber: "رقم العميل",
    customerName: "اسم الشركة/اسم المورد",
    sixMonthAvgPrice: "السعر المتوسط للمشترين على مدى 6 أشهر (باستثناء الضرائب)",
    minPrice: "السعر الأدنى (باستثناء الضريبة)",
    minPriceCustomerNumber: "رقم مورد الأسعار الأقل",
    minPriceCompanyName: "اسم الشركة المورّة بأقل سعر",
    minPriceCustomerPhone: "المورد الذي يقدم أقل سعرًا: رقم الهاتف",
    priceValidityPeriod: "فترة صلاحية السعر",
    priceStartEffectiveDate: "تبدأ الأسعار من الآن فصاعدًا",
    priceExpirationDate: "تاريخ انتهاء الصلاحية للسعر",
    noImage: "لا صور",
    orderBy1: " فرز المعلومات حسب وقت الدخول ",
    orderBy2: " فرز حسب تاريخ الدخول ",
    orderBy3: " فرز حسب تاريخ المغادرة ",
    createProduct: "إنشاء منتج",
    editProduct: "تعديل المنتج",
    grossWeight: "الوزن الإجمالي للقطعة الواحدة (كجم)",
    volume: "الحجم الواحد (م³)",
    countryOrigin: "مكان المنشأ/البلد",
    startDate: " تاريخ البدء ",
    to: "إلى",
    endDate: "تاريخ الأنتهاء",
    brandLicensing: "ترخيص العلامة التجارية",
    brandLicensingDate: "فترة ترخيص العلامة التجارية",
    sort: "ترتيب",
    qOrderBy1: "ترتيب تنازلي لتواريخ الاقتباس",
    qOrderBy2: "فرز حسب تاريخ الاقتباس في ترتيب تصاعدي",
    qOrderBy3: "سعر الشراء قبل الضرائب في ترتيب descendent",
    qOrderBy4: "الترتيب الصاعد لأسعار الشراء قبل الضرائب",
    qOrderBy5: "ترتيب هبوطي لأسعار الشراء بعد الضرائب",
    qOrderBy6: "الترتيب الصاعد لأسعار الشراء بعد الضرائب",
    qNumber: "رقم الاقتباس",
    supplier: "المورد",
    supplierNumber: "رقم المورد",
    supplierName: "اسم المورد",
    preTaxPurchasePrice: "السعر الشرائي قبل الضرائب",
    invoicingTaxRate: "معدل الضريبة لإصدار الفواتير",
    invoiceType: "نوع الفاتورة",
    invoiceType1: "تقرير فرنسي خاص بضريبة القيمة المضافة",
    invoiceType2: "تقرير ضريبة القيمة المضافة العام",
    afterTaxPurchasePrice: "السعر الشرائي بعد الضريبة",
    invoiceIncludingTaxRate: "مُشَتَّر بسعر ضريبة",
    productTaxAmount: "مقدار ضريبة المنتج",
    productState: "حالة المنتج",
    normal: "طبيعي",
    disable: "تعطيل",
    quoteDate: "تاريخ الاقتباس",
    createQuotation: "إنشاء اقتباس",
    minimumOrderQuantity: "كمية الطلب الدنيا",
    procurementConsiderations: "اعتبارات المشتريات",
  },
  tradeOrder: {
    jobNumber: "رقم الوظيفة",
    orderNumber: "رقم الطلب",
    customerNumber: "رقم العميل",
    customerCompanyName: "اسم شركة العميل",
    tradeTerms: "شروط التجارة",
    deliveryDestination: "وجهة التسليم",
    totalReceive: "إجمالي المستحقات",
    receivable: "الرصيد المعلق للتحصيل",
    taxRefundTotalAmount: "إجمالي المبلغ المؤهل لاسترداد الضريبة",
    procurementTotalAmount: "إجمالي المبلغ المستحق السداد",
    paymentBalance: "الرصيد غير المدفوع",
    financialAccountNo: "رقم المرجع المالي",
    companyNameSn: "اختصار العميل",
    invoiceNo: "رقم الفاتورة.",
    totalPayable: "إجمالي المبلغ المدفوع",
    totalPayableBalance: "الرصيد المستحق الدفع",
    totalReceive: "إجمالي المبلغ المستحق",
    totalReceiveBalance: "الرصيد القابل للاسترداد",
    viewCost: "عرض التكلفة",
    deleteCost: "حذف التكلفة",
    viewSell: "عرض البيع",
    deleteSell: "احذف البيع",
    subTotal: "المجموع الفرعي",
    rate: "سعر الصرف",
    totalAmount: "الإجمالي",
    receTotalAmount: "المبلغ الإجمالي",
    profitTotalAmount: "المبلغ الإجمالي",
    notice: "إشعار",
    deleteCheck1: "هل أنت متأكد من حذف هذه التكلفة؟",
    deleteCheck2: "هل أنت متأكد من حذف هذا البيع؟",
    nuType1: "مستحقات",
    nuType2: "مدفوعات",
    sheet1: "إشعار مدين",
    sheet2: "تكاليف المورد",
    reconciliation: "توفيق حسابات رأس مال العميل",
    printTitle: "طباعة أمر التجارة",
    printOption1: "قائمة المشتريات",
    printOption2: "قائمة المنتجات المباعة",
    createOrder: "إنشاء أمر تجاري",
    viewDraft: "عرض المسودة",
    deleteDraft: "حذف المسودة",
    saveDraft: "حفظ المسودة",
    draftName: "الاسم المُعدّل",
    productNameSn: "اسم المنتج",
    brand: "العلامة التجارية",
    model: "الطراز",
    specifications: "المواصفات",
    searchProduct: "البحث عن منتج",
    noImage: "لا توجد صورة متاحة",
    productName: "اسم المنتج",
    productNameEn: "اسم المنتج بالإنجليزية",
    customsDeclarationName: "اسم الإقرار الجمركي",
    customsDeclarationInfo: "معلومات الإقرار الجمركي",
    domesticPlaceOrigin: "مكان المنشأ المحلي",
    unitName: "وحدة عرض السعر",
    hsCode: "رمز النظام المنسق",
    supplier: "المورد",
    quotation: "عرض سعر الشراء",
    entity: "الكيان التجاري",
    quantity: "كمية الشراء",
    preTaxPurchasePrice: "سعر الشراء قبل الضريبة",
    invoicingTaxRate: "نسبة ضريبة الفوترة",
    afterTaxPurchasePrice: "سعر الشراء بعد الضريبة",
    minimumOrderQuantity: "الحد الأدنى لكمية الطلب",
    procurementConsiderations: "اعتبارات الشراء",
    collapse1: "أمر الشراء",
    collapse2: "أمر البيع",
    subTitle1: "قائمة منتجات الشراء",
    subTitle2: "قائمة منتجات البيع",
    button1: "إضافة كتالوج الشراء",
    button2: "مزامنة المنتج",
    button3: "تضمين في المستحقات",
    total1: "إجمالي كمية الشراء",
    total2: "إجمالي مبلغ الشراء (يوان صيني)",
    total3: "إجمالي سعر بيع الطلب",
    total4: "إجمالي سعر بيع الطلب (يوان صيني)",
    total5: "إجمالي مبلغ الرسوم",
    total6: "إجمالي مبلغ الرسوم (يوان صيني)",
    total7: "إجمالي المستحقات المتوقعة للطلب (يوان صيني)",
    total8: "إجمالي الربح المتوقع للطلب (يوان صيني)",
    total9: "هامش الربح",
    total10: "إجمالي استرداد الضريبة المتوقع",
    subtotal: "المجموع الفرعي",
    refundSubtotal: "المجموع الفرعي لاسترداد الضريبة",
    customerName: "اسم العميل",
    accountNo: "الحساب البنكي",
    bankAccount: "حساب الاستلام",
    contact: "جهة الاتصال",
    phoneNumber: "رقم الهاتف",
    deliveryCountry: "بلد التسليم",
    deliveryDestination: "وجهة التسليم",
    address: "العنوان",
    tradeTerms: "شروط التجارة",
    procurementFeeRate: "نسبة رسوم الشراء",
    tradeCurrency: "عملة المعاملة",
    exchangeRate: "سعر الصرف للمعاملة",
    fobCurrency: "عملة التكلفة المحلية FOB",
    fobCost: "التكلفة المحلية FOB",
    jobNumber: "رقم المهمة",
    orderNumber: "رقم الطلب",
    checkbox1: "طلب استرداد ضريبة التصدير",
    salesUnitPrice: "سعر البيع",
    deleteSuccess: "تم الحذف بنجاح",
    synError: "يرجى إضافة كتالوج الشراء أولاً",
    quantityError: "لا يمكن أن تكون كمية الشراء أقل من الحد الأدنى لكمية الطلب",
    updateSuccess: "تم تحديث منتج الشراء",
    addSuccess: "تمت الإضافة بنجاح",
    pickerError1: "هذا العميل لا يمتلك حسابًا بنكيًا لاستلام المدفوعات",
    pickerError2: "لا تمتلك هذه الكيانات التجارية حسابًا بنكيًا لاستقبال المدفوعات",
    pickerError3: "لا يوجد مورد لهذا المنتج",
    pickerError4: "لا توجد اقتباسات لهذا المنتج"
  },
  procurementQuotationSettings: {
    createUnit: "إنشاء وحدة اقتباس",
    editUnit: "تعديل وحدة الاقتباس",
    unitNameCN: "اسم الوحدة باللغة الصينية",
    unitNameEN: "اسم الوحدة باللغة الإنجليزية",
    unitNameAR: "اسم الوحدة بالعربية",
  },
  freightInquiry: {
    tableTitle: "خدمة عرض الأسعار",
    placeHolder: "يرجى اختيار البلد",
    divider: "الوزن الإضافي",
    col1: "فئة السلعة",
    col2: "وحدة الوزن الأساسية",
    col3: "سعر وحدة الوزن الأساسية",
    col4: "الوزن الإضافي",
    col5: "سعر وحدة الوزن الإضافي",
    col6: "زمن النقل",
    day: "أيام",
    warehouseContact: "جهة الاتصال",
    warehousePhone: "رقم الاتصال",
    warehouseAddress: "عنوان المستودع",
    copy: "انقر للنسخ",
    empty: "لا توجد بيانات",
    none: "لا شيء",
    remark: "ملاحظة",
    supplier: "المورد",
    area: "المنطقة",
    bcName: "التصنيف التجاري",
    updateTime: "تاريخ التحديث",
    companyNameKeyword: "اسم المورد كلمة مفتاحية",
    countryName: "اسم البلد",
    cargoCategory: "خدمة النقل",
    freightPriceCalculator: "حاسبة أسعار الشحن",
    tab1: "الدفع بالبطاقة",
    tab2: "الخدمات الأخرى",
    quotationDetail: "تفاصيل التسعير",
    customerNumber: "رقم العميل",
    customerCompanyName: "اسم شركة العميل",
    awWay: "طريقة الوصول",
    dCurrnecy: "عملة العرض",
    dCurrnecySymbol: "رمز عملة العرض",
    weight: "الوزن",
    volume: "الحجم",
    shipmentCount: "عدد بوالص الشحن الرئيسية",
    billCount: "عدد بوالص الشحن الفرعية",
    cifGoodsValue: "قيمة البضائع سيف",
    piecesNumber: "عدد القطع",
    storageOverdueDays: "أيام التخزين المتأخرة",
    conatiner20: "نوع حاوية 20",
    conatiner40: "40 نوع الحاوية",
    conatiner40HQ: "نوع الحاوية 40HQ",
    isCustomsInspection: "هل هناك فحص جمركي؟",
    isMandatoryItem: "هل هذا عنصر أساسي؟",
    mandatory1: "تحصيل إلزامي",
    mandatory2: "تحصيل عند الإرسال",
    mandatory3: "صرف فعلي حسب المستندات لكل طلب",
    notes: "ملاحظات تشغيلية",
    feeSchedule: "جدول الرسوم",
    itemName: "اسم بند الفاتورة",
    unitName: "اسم وحدة الفوترة",
    costPrice: "سعر التكلفة",
    totalCostPrice: "إجمالي سعر التكلفة"
  },
  address: {
    addAddress: "إنشاء عنوان التسليم ",
    editAddress: "تعديل عنوان التسليم",
    postcode: "الرمز البريدي",
    receivingName: "المستلم",
    phoneNumber: "رقم الاتصال",
    receivingAddress: "تفاصيل عنوان التسليم",
    isDefault: "عنوان التسليم الافتراضي",
    selectAddress: "الرجاء اختيار العنوان",
    chinese1: "عنوان توصيلك الصيني",
    chinese2: "مستودع",
    chinese3: "الاتصال",
    chinese4: "الهاتف",
    chinese5: "العنوان",
    copy: "انقر للنسخ"
  },
  myWallet: {
    accountBalance: "رصيد الحساب",
    processAccountBalance: "المبلغ المُخصَّم",
    fundType1: "شحن",
    fundType2: "استهلاك",
    fundType3: "قيد صرف العملات",
    fundType4: "صرف النفقات",
    balance: "الرصيد",
    fundTypeStr: "نوع التمويل",
    tradeNumber: "رقم الصفقة",
    rechargeAmount: "مبلغ الشحن",
    rechargeTime: "وقت الشحن",
    paymentMethod: "طريقة الدفع",
    payment1: "أليباي",
    payment2: "وي تشات",
    payment4: "دفع خارجي",
    orderState: "حالة الطلب",
    pState1: "في انتظار الدفع",
    pState2: "تم الدفع",
    pState3: "ملغي",
    entryState: "حالة القيد",
    eState1: "في انتظار المراجعة",
    eState2: "تم القيد",
    eState3: "ملغي",
    tab1: "سجل الشحن",
    tab2: "كشف الحساب",
    listButton: "الدفع / العرض",
    rechangeButton: "إعادة شحن الحساب",
    payAmount: "مبلغ الدفع",
    payVoucher: "تذكرة الدفع",
    tradeCurrency: "عملة المعاملة",
    accountName: "اسم الحساب",
    accountNumber: "رقم الحساب",
    tips1: "ملاحظات هامة",
    tips2: "بغض النظر عن طريقة الدفع المختارة، لن يتم إضافة الأموال إلى رصيدك فوراً بعد عملية الشحن الناجحة. يجب التحقق منها من قبل مدقق حسابات، وعادةً ما تتم المراجعة خلال 1-2 يوم عمل. يرجى التحلي بالصبر. إذا لم تُضف الأموال بعد فترة طويلة، يرجى الاتصال بالمسؤول مباشرة للحصول على المساعدة.",
    cancelPayment: "إلغاء الدفع",
    payNow: "أدفع الآن"
  },
  paybillList: {
    totalAmount: "المبلغ الإجمالي",
    approvedAmount: "المبلغ المعتمد",
    billState1: "غير مدفوع",
    billState2: "مدفوعة الأجر",
    billState3: "لا مراجعة",
    subTotalAmount: "المبلغ الإجمالي الفرعي",
    subApprovedAmount: "المبلغ المعتمد من الباطن",
    chargeMoney: "بنود الشحن",
    payableBills: "فاتورة مستحقة الدفع",
    onPay: "ادفع الآن",
  },
  order: {
    payType: "اختر طريقة الدفع",
    onPay: "ادفع الآن",
    paymentOption1: "Alipay",
    paymentOption2: "Wechat",
  },
  orderManagement: {
    search1: "رقم الطلب / الشحن / بيان الشحن",
    search2: "المستلم / الشاحن",
    orderNo: "رقم الطلب",
    expressNo: "رقم الشحن",
    wbNumber: "رقم بيان الشحن",
    serviceProvider: "مزود الخدمة",
    none: "لا يوجد",
    cargoCategory: "خدمة النقل",
    shipper: "الشاحن",
    shipperName: "اسم الشاحن / الهاتف",
    shipperContact: "جهة اتصال الشاحن",
    shipperPhoneNumber: "رقم هاتف الشاحن",
    consignee: "المستلم",
    consigneeName: "اسم المستلم / الهاتف",
    consigneeContact: "جهة اتصال المستلم",
    declareValue: "القيمة المصرح بها",
    declareValueCurrency: "عملة القيمة المصرح بها",
    itemsTitle: "تفاصيل البضائع",
    weight: "الوزن",
    volume: "الحجم",
    boxNumber: "عدد الصناديق",
    orderDate: "تاريخ الطلب",
    addButton: "إنشاء طلب",
    skuName: "اسم المنتج",
    skuQty: "الكمية",
    hsCode: "رمز النظام المنسق",
    companyName: "اسم الشركة",
    contactName: "اسم جهة الاتصال",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    zipCode: "الرمز البريدي",
    detailAddress: "العنوان التفصيلي",
    naqel_ShippingDateTime: "وقت الشحن",
    naqel_DescriptionOfGoods: "وصف البضائع",
    naqel_NumberOfPieces: "عدد القطع",
    iMile_PackageTotalVolume: "الحجم الإجمالي للطرود",
    iMile_PackageGrossWeight: "الوزن الإجمالي للطرد",
    iMile_PackageTotalCount: "إجمالي عدد الطرود",
    iMile_PackageGoodsType: "نوع بضائع الطرد",
    itemsTotal: "ملخص البيانات",
    totalWeight: "الوزن الإجمالي",
    totalValue: "الحجم الإجمالي",
    totalBoxNumber: "إجمالي عدد الصناديق",
    totalQuantity: "إجمالي كمية البضائع",
    orderDetail: "تفاصيل الطلب",
    createOrder: "إنشاء طلب",
    others: "أخرى",
    declareTitle: "تفاصيل الإقرار",
    productCategory: "فئة المنتج",
    taxFeebearingParty: "المُدَّعِي الضريبي",
  },
  exportGoodsStatistics: {
    receiveCountry: "دولة الاستلام",
    receiveCity: "إستلم المدينة",
    transportType: "نوع النقل",
    goodsName: "اسم البضاعة",
    hsCode: "كود HS",
  }
};
export default messages;
